import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, isDevMode, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as LogRocket from 'logrocket';
import * as moment from 'moment-timezone';
import { ConfirmationService } from 'primeng/api';
import { debounceTime, distinctUntilChanged, fromEvent, tap } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics.service';
import { KioskPaymentService } from 'src/app/core/services/kiosk-payment.service';
import { LocalDataStoreService } from 'src/app/core/services/local-data-store.service';
import { OnlineOrderService } from 'src/app/core/services/online-order.service';
import { OrderSocketService } from 'src/app/core/services/order-socket.service';
import { PaymentRequestService } from 'src/app/core/services/payment-request.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { AddressSelectionInputComponent } from 'src/app/shared/components/address-selection-input/address-selection-input.component';
import { AddressModel } from 'src/app/shared/models/address.model';
import { CheckDto, CheckItemDto } from 'src/app/shared/models/check-dto';
import { CustomerLegacy } from 'src/app/shared/models/Customer-legacy';
import { CustomerDto } from 'src/app/shared/models/DTO/customer-dto';
import { DatacapPaymentStatus } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapAuthResponse.dto';
import { GiftProcessedDTO } from 'src/app/shared/models/DTO/giftcard.dto';
import { I4goPaymentResponseDTO } from 'src/app/shared/models/DTO/I4goPaymentRequest.dto';
import { OnlineCredit, OnlineCustomer, OnlineCustomerCode } from 'src/app/shared/models/DTO/onlineCustomer.model';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { CCProcessors } from 'src/app/shared/models/enums/CCProcessors.enum';
import { CheckStatus } from 'src/app/shared/models/enums/CheckStatus.enum';
import { FocusLinkProduct } from 'src/app/shared/models/enums/FocusLInkProduct.enum';
import { LogLevel } from 'src/app/shared/models/enums/log-level.enum';
import { OrderSocketMessage } from 'src/app/shared/models/enums/order-socket-message.enum';
import { OrderTypeIncludeNameFormat } from 'src/app/shared/models/enums/order-type-include-name-format.enum';
import { OrderTypeIncludeNamePrefix } from 'src/app/shared/models/enums/order-type-include-name-prefix.enum copy';
import { OrderDelayMethod } from 'src/app/shared/models/enums/OrderDelayMethod.enum';
import { ProductUseFunction } from 'src/app/shared/models/enums/ProductUseFunction.enum';
import { GuestVenue } from 'src/app/shared/models/focusDataModels/GuestVenue';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';
import { OOCheck } from 'src/app/shared/models/oo-check';
import { OOCheckItem } from 'src/app/shared/models/oo-check-item';
import { OOLink } from 'src/app/shared/models/oo-link';
import { OOMenuConfig } from 'src/app/shared/models/oo-menu-config';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { OOOrderType } from 'src/app/shared/models/oo-order-type';
import { OOOrderTypeDeliveryZone } from 'src/app/shared/models/oo-order-type-delivery-zone';
import { OOOrderTypeThrottle } from 'src/app/shared/models/oo-order-type-throttle';
import { OOTags } from 'src/app/shared/models/oo-tags.model';
import { OOVenue } from 'src/app/shared/models/oo-venue';
import { OOAliasUrl } from 'src/app/shared/models/OOAliasUrl.model';
import { OOTimeRanges } from 'src/app/shared/models/OOTimeRanges.entity';
import { Order, OrderItem, OrderPayment, OrderSeat, OrderValidateRes } from 'src/app/shared/models/order';
import { OrderPaymentTypes } from 'src/app/shared/models/order-payment-types.enum';
import * as uuid from 'uuid';
import { environment } from '../../../environments/environment';
import { FocuslinkService } from '../../core/services/focuslink.service';
import { FocusSidebarComponent } from '../../shared/components/focus-sidebar/focus-sidebar.component';

declare var $: any;
declare function onApplePayClick(e: any);
declare var Accept: any;

@Component({
	selector: 'app-online-order',
	templateUrl: './online-order.component.html',
	styleUrls: ['./online-order.component.scss'],
})
export class OnlineOrderComponent implements OnInit, AfterViewInit {
	@ViewChild('authNetBtn') authNetBtn: ElementRef;
	@ViewChild('panelLogin', { static: false }) panelLogin;
	@ViewChild('promoModalTemplate', { static: false }) promoModalTemplate;
	@ViewChild('sbCart', { static: true }) sbCart: FocusSidebarComponent;
	@ViewChild('addressSelect', { static: false }) addressSelect: AddressSelectionInputComponent;
	@ViewChild('canvasSelect', { static: true }) canvasSelect: ElementRef;
	@ViewChild('searchItemValue') searchItemValue: ElementRef;
	@ViewChild('menuItemModalTemplate') menuItemModalTemplate: TemplateRef<any>;
	@ViewChildren('div')
	divs: QueryList<any>;

	addressGeo: AddressModel;
	addressAutoCompleteValue: string;
	alert: string;
	allowOrder: boolean;
	allowSubmit = true;
	authNetApiLoginId: string;
	acceptingOrdersMessage: string;

	canvasMenuItems: OOCanvasMenuItem[] = [];
	canvasMenuItemsWithTags: OOCanvasMenuItem[] = [];
	canvasSelected: OOCanvas;
	check: OOCheck;
	checkItemIdx: number;
	checkoutStep: any = 'check';
	checkoutStepNum: number = 0;
	continueMessage;

	customer: CustomerLegacy;
	customerDto: CustomerDto;
	customerCardToken: string;
	customerCards: any[];
	customerEmail: string;

	deliveryAllowed: boolean = true;
	deliveryZone: OOOrderTypeDeliveryZone;
	displayTos: boolean = false;
	dueDateTimeMessage: string;

	error: string;

	filteredMenuItems: OOMenuItem[];
	futureOrderDate = new Date();
	futureOrderMaxDate = moment().add(1, 'year').toDate();
	futureOrderMinDate = new Date();
	futureOrderOptions = [];
	futureOrderTime;
	futureOrderTimeOptions = [];
	// futureOrderTimeSlots = [];

	giftAccount: string;
	giftAmount: number;
	giftBalanceAmount: number;
	guestProfile: GuestVenue;

	isDevMode: boolean;
	isMobile: boolean;
	i4go_accessBlock: any;
	i4goCardOther: boolean = false;
	i4go_server: any;
	i4goWalletEnabled: {
		applePay: boolean;
		googlePay: boolean;
	};

	kioskMode: boolean = false;
	kioskDeviceId: string;

	linkedMenuConfig: OOMenuConfig;
	linkedVenue: OOVenue;
	link: OOLink;
	loggingIn: boolean;
	loading: boolean;

	menuItemComment1: string;
	menuItemComment2: string;
	menuItemModalDisplay: boolean;
	menuItemModifiers;
	menuItemQty: number;
	menuItemSelected: OOMenuItem;
	menuItemSubModifiers;
	menuItemTagList: OOTags[] = [];
	menuItemTotal: number;
	message: string;
	modalRef: NgbModalRef;
	moment: any = moment;

	now = moment();

	onlineCustomer: OnlineCustomer;
	ooCanvases: OOCanvas[];
	ooCanvasesOnline: OOCanvas[];
	ooMenuConfig: OOMenuConfig;
	ooMenuItems: OOMenuItem[];
	order: Order;
	orderAcceptanceStartTime: moment.Moment;
	orderDelayMethod: number;
	orderPayment: OrderPayment;
	orderStatusMessage: string;
	orderStatusEmitterListener: string;
	orderThrottleRule: OOOrderTypeThrottle;
	orderTime: string = 'ASAP';
	orderDueDateTime: string;
	orderTimeTypeChange: boolean = false;
	orderType: OOOrderType;
	orderTypeOptions: any[];

	password: string;
	passwordConfirm: string;
	paymentAuthorization: any;
	paymentInvoiceNumber: number;
	paymentMode;
	paymentUseNewCard: boolean = true;
	paymentResult: any;
	paymentToken: string;
	priceLevels: any[];

	receiptUrl;

	savedCheck: CheckDto;
	saving: boolean;
	savingLoyalty: boolean;
	savingNewCustomer: boolean;
	selectedCanvasKey: number;
	selectedCanvas: OOCanvas;
	search: boolean;
	searchItemResults: OOCanvasMenuItem[] = [];
	searchTerm: string;
	searchTags: any[];
	shareCheckView: boolean = false;
	showFilterOptions: boolean;
	showPriceLevels: boolean;
	showModifiers: boolean;
	showModal: boolean;

	tagFilters: string[] = [];
	tipCustom: number;
	tipOptions = [];
	tipSelected: number;
	timeRangeList: OOTimeRanges[];
	timeRangeActive: OOTimeRanges[];
	timestamp = moment().valueOf();

	useKey: string;

	validCheck: OrderValidateRes;
	venue: OOVenue;
	venueAlias: string;
	venueKey: number;

	query = {
		betaUi: null,
		checkKey: null,
		force: null,
		linkKey: null,
		mode: null,
		menuKey: null,
		newcheck: null,
		orderType: null,
		table: null,
		test: null,
		canvasMenuItem: null,
		kiosk: null,
	};

	duration = {
		start: undefined,
		ngoninit: undefined,
		datafetched: undefined,
		pageLoaded: undefined,
	};

	constructor(
		private confirmationService: ConfirmationService,
		private focuslink: FocuslinkService,
		private googleAnalytics: GoogleAnalyticsService,
		private orderSocketService: OrderSocketService,
		private route: ActivatedRoute,
		private storage: LocalDataStoreService,
		private titleService: Title,
		public app: AppService,
		public breakpointObserver: BreakpointObserver,
		public payment: PaymentRequestService,
		public onlineOrderService: OnlineOrderService,
		public venueService: OOVenueService,
		public kioskPaymentService: KioskPaymentService
	) {}

	ngOnInit() {
		this.duration.start = new Date().getTime();
		this.breakpointObserver.observe(['(max-width: 450px)']).subscribe((state: BreakpointState) => {
			if (state.matches) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}
		});

		const venueKeyOrAlias = this.route.snapshot.paramMap.get('storeKey');
		if (venueKeyOrAlias && venueKeyOrAlias.length <= 6 && !isNaN(+venueKeyOrAlias)) {
			this.venueKey = +this.route.snapshot.paramMap.get('storeKey');
		} else {
			this.venueAlias = this.route.snapshot.paramMap.get('storeKey');
		}

		this.query.mode = this.route.snapshot.queryParamMap.get('mode');
		this.query.checkKey = this.route.snapshot.queryParamMap.get('checkKey');
		this.query.linkKey = this.route.snapshot.queryParamMap.get('linkKey');
		this.query.menuKey = this.route.snapshot.queryParamMap.get('menuKey');
		this.query.orderType = this.route.snapshot.queryParamMap.get('ot');
		this.query.force = this.route.snapshot.queryParamMap.get('force');
		this.query.newcheck = this.route.snapshot.queryParamMap.get('newcheck');
		this.query.test = this.route.snapshot.queryParamMap.get('test') === 'true' ? true : false;
		this.query.betaUi = this.route.snapshot.queryParamMap.get('beta');
		this.query.canvasMenuItem = this.route.snapshot.queryParamMap.get('ik');
		this.query.kiosk = this.route.snapshot.queryParamMap.get('kiosk') === 'true' ? true : false;

		if (this.route.snapshot.queryParamMap.get('kioskreset')) {
			this.kioskPaymentService.removeLicense();
		}

		if (this.query.canvasMenuItem) {
			this.query.canvasMenuItem = atob(this.query.canvasMenuItem);
		}
		if (!this.query.canvasMenuItem) {
			this.query.canvasMenuItem = this.route.snapshot.queryParamMap.get('cmi');
		}
		this.isDevMode = isDevMode();

		this.init();
		this.duration.ngoninit = this.app.references.duration(this.duration.start);
	}

	ngAfterViewInit(): void {}

	acceptingOrders(venue: OOVenue) {
		this.acceptingOrdersMessage = undefined;
		if (this.query.force === 'true') {
			return true;
		}
		if (venue.posStatus === 0) {
			return false;
		}
		if (!venue.orderActive) {
			return false;
		}
		if (!venue.timeRanges) {
			return true;
		}
		let value = false;
		let reason = undefined;
		const day = moment().day();
		const start1 = venue.timeRanges[`day${day + 1}Start1`];
		const end1 = venue.timeRanges[`day${day + 1}End1`];
		const start2 = venue.timeRanges[`day${day + 1}Start2`];
		const end2 = venue.timeRanges[`day${day + 1}End2`];

		if (!start1 && !start2) {
			return true;
		}

		const current = moment().utc();

		let start1Moment;
		let end1Moment;
		if (start1 && end1) {
			start1Moment = moment(start1, 'h:mma').tz(venue.timezone).utc();
			end1Moment = moment(end1, 'h:mma').tz(venue.timezone).utc();

			if (current.isBetween(start1Moment, end1Moment)) {
				value = true;
			}
		}

		let start2Moment;
		let end2Moment;
		if (start2 && end2) {
			start2Moment = moment(start2, 'h:mma').tz(venue.timezone).utc();
			end2Moment = moment(end2, 'h:mma').tz(venue.timezone).utc();

			if (current.isBetween(start2Moment, end2Moment)) {
				value = true;
			}
		}

		console.log(`Accepting Orders: ${value}`);
		let orderAcceptanceWindow = `Order Hours: ${current.tz(this.venue.timezone).format('dddd')} ${start1Moment
			.tz(this.venue.timezone)
			.format('LT')}-${end1Moment.tz(this.venue.timezone).format('LT')}.`;

		if (start2Moment.tz(this.venue.timezone).format('LT') !== end2Moment.tz(this.venue.timezone).format('LT')) {
			orderAcceptanceWindow += ` & ${start2Moment.tz(this.venue.timezone).format('LT')}-${end2Moment.tz(this.venue.timezone).format('LT')}`;
		}
		console.log(orderAcceptanceWindow);
		console.log(`Current time: ${current.format('LT')}`);

		this.orderAcceptanceStartTime = start1Moment.tz(this.venue.timezone);

		if (!value) {
			this.acceptingOrdersMessage =
				venue.outsideOfOrderTimeWindowMessage ||
				'Sorry, we are not accepting orders at this time. Please check back with us soon.' + '\n\n\n' + orderAcceptanceWindow;
		}
		return value;
	}

	applePayClick() {
		const e = { preventDefault: () => {} };
		onApplePayClick(e);
	}

	async i4goPaymentToOrderPayment(payment: I4goPaymentResponseDTO) {
		this.dev(payment);
		this.orderPayment = new OrderPayment({
			amount: this.check.total,
			tip: this.check.tip,
			token: payment.token,
			type: OrderPaymentTypes.CreditCard,
			firstName: payment.firstName,
			lastName: payment.lastName,
			address1: this.check.billing.address1,
			city: this.check.billing.city,
			state: this.check.billing.state,
			postalCode: payment.postalCode,
			securityCode: payment.securityCode,
			extendedCardData: payment.extendedCardData,
			pspReference: payment.pspReference,
			sendToProcessor: payment.sendToProcessor,
			kioskPaymentRequestKey: payment.kioskPaymentRequestKey,
		});
		this.paymentToken = payment.token;
		if (!payment.sendToProcessor) {
			this.paymentAuthorization = payment.extendedCardData;
		}

		if (this.onlineCustomer) {
			if (!this.onlineCustomer.creditCards) {
				this.onlineCustomer.creditCards = [];
			}
			if (!payment.applePayToken && !payment.googlePayToken) {
				if (this.onlineCustomer.creditCards.some((i) => i.token === payment.token)) {
					const existingToken = this.onlineCustomer.creditCards.find((i) => i.token === payment.token);
					existingToken.lastUsed = new Date();
				} else {
					this.onlineCustomer.creditCards.push(
						new OnlineCredit({
							token: payment.token,
							displayName: payment.displayName,
							expirationMonth: payment.expirationMonth,
							expirationYear: payment.expirationYear,
							type: payment.cardType,
							lastUsed: new Date(),
						})
					);
				}

				this.storage.set(OnlineCustomerCode.ONLINECUSTOMER, this.onlineCustomer);
			}
		}

		await this.processOrder(this.order);
	}

	changeOrderTime() {}

	clearAddress() {
		this.addressGeo = new AddressModel();
		this.check.shipping.address1 = undefined;
		this.check.shipping.address2 = undefined;
		this.check.shipping.city = undefined;
		this.check.shipping.state = undefined;
		this.check.shipping.postalCode = undefined;
	}

	clearCheck() {
		this.savedCheck = null;
		if (this.check) {
			this.check.items = null;
			this.check.subtotal = 0;
			this.check.orderTypeFee = 0;
			this.check.creditCardPassAlongFee = 0;
			this.check.tax = 0;
			this.check.tip = 0;
			this.check.total = 0;
		}
		this.check = new OOCheck();
		this.check.checkKey = uuid.v4();
	}

	async customerGet(customerKey: string) {
		if (this.venueKey === 7166) {
			const resp = await this.focuslink.customerGetOne(this.venueKey, customerKey, true);
			this.customerDto = new CustomerDto(resp);
			this.googleAnalytics.event('return_customer', 'customer', 'return', this.customerDto.key);
		}
	}

	delay(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	enableSearch() {
		this.search = !this.search;
		if (this.search) {
			setTimeout(() => {
				fromEvent(this.searchItemValue.nativeElement, 'keyup')
					.pipe(
						debounceTime(500),
						distinctUntilChanged(),
						tap((text) => {
							this.searchForItems(text);
						})
					)
					.subscribe();
			}, 250);
		}
	}

	generateOrder(check: OOCheck, skipLocked?: boolean) {
		const order = new Order({
			venueKey: this.venueKey,
			checkKey: this.check.checkKey,
			orderType: this.check.orderType,
			seats: [new OrderSeat()],
		});

		order.seats[0].items = [];
		order.seats[0].payments = [];

		for (const item of check.items) {
			if (!skipLocked || (skipLocked && !item.locked)) {
				const orderItem = new OrderItem({
					menuItemKey: item.key,
					price: item.price,
					quantity: item.qty,
					name: item.name,
					priceNumber: item.priceNumber,
					priceNumberName: item.priceNumberName,
					uuid: item.uuid,
				});
				if (item.modifiers) {
					orderItem.modifiers = [];
					for (const mod of item.modifiers) {
						if (mod.kitchenComment) {
							orderItem.modifiers.push(
								new OrderItem({
									menuItemKey: mod.key,
									price: mod.price,
									quantity: 1,
									name: mod.name,
									kitchenComment: true,
								})
							);
						}
						if (!mod.kitchenComment) {
							if (mod.level === 1) {
								orderItem.modifiers.push(
									new OrderItem({
										menuItemKey: mod.key,
										price: mod.price,
										quantity: 1,
										name: mod.name,
										priceNumber: mod.priceNumber,
										priceNumberName: mod.priceNumberName,
									})
								);
							}
							if (mod.level === 2) {
								const parentMod = orderItem.modifiers[orderItem.modifiers.length - 1];
								parentMod.modifiers = parentMod.modifiers || [];
								parentMod.modifiers.push(
									new OrderItem({
										menuItemKey: mod.key,
										price: mod.price,
										quantity: 1,
										name: mod.name,
										priceNumber: mod.priceNumber,
										priceNumberName: mod.priceNumberName,
									})
								);
							}
						}
					}
				}
				order.seats[0].items.push(orderItem);
			}
		}

		Object.keys(check.meta).forEach((k) => {
			if (this.check.meta[k]) {
				order.seats[0].items.push(
					new OrderItem({
						menuItemKey: this.linkedMenuConfig ? this.linkedMenuConfig.commentsMenuId : this.ooMenuConfig.commentsMenuId,
						price: 0,
						quantity: 1,
						name: k,
						kitchenComment: true,
						modifiers: [
							new OrderItem({
								menuItemKey: this.linkedMenuConfig ? this.linkedMenuConfig.commentsMenuId : this.ooMenuConfig.commentsMenuId,
								price: 0,
								quantity: 1,
								name: this.check.meta[k],
								kitchenComment: true,
							}),
						],
					})
				);
			}
		});

		// const remainingBalance = this.paymentMode === 'store' && this.check.total;
		// let dueDateTime = moment.utc().add(this.venue.orderLeadTime, 'minutes').format();
		if (this.check.futureOrder === 'later' && this.futureOrderDate && this.futureOrderTime) {
			order.futureOrder = true;
			order.dueDateTime = moment(this.futureOrderDate)
				.hour(this.futureOrderTime.split(':')[0])
				.minute(this.futureOrderTime.split(':')[1])
				.second(0)
				.utc()
				.format();
		} else {
			order.dueDateTime = moment.utc().add(check.leadTime, 'minutes').format();
			// if (this.orderType && this.orderType.orderLeadTime) {
			// 	order.dueDateTime = moment.utc().add(this.orderType.orderLeadTime, "minutes").format();
			// } else {
			// 	order.dueDateTime = moment.utc().add(this.check.leadTime, "minutes").format();
			// }
		}
		//
		//~ THIS MAY NEED TO CHANGE IF JOSH WANTS THE ORDER TYPE LEAD TIME INVOKED ORDERS TO BE SENT ASAP
		//

		if (
			this.orderDelayMethod === OrderDelayMethod.THROTTLEREVENUE ||
			(check.leadTime > this.venue.orderLeadTime && this.orderDelayMethod === OrderDelayMethod.VENUE)
		) {
			order.futureOrder = true;
		}

		return order;
	}

	async evaluateDeliveryZone(): Promise<boolean> {
		this.deliveryZone = undefined;
		let highestFee = 0;
		for (let zone of this.orderType.OOOrderTypeDeliveryZone) {
			const deliveryZone = new google.maps.Polygon({ paths: JSON.parse(zone.vertices) });
			const point: google.maps.LatLng = new google.maps.LatLng(this.addressGeo.latitude, this.addressGeo.longitude);
			if (google.maps.geometry.poly.containsLocation(point, deliveryZone)) {
				if (zone.deliveryFee >= highestFee) {
					this.deliveryZone = zone;
				}
			}
		}
		if (this.deliveryZone) {
			console.clear();
			this.dev('In zone');
			this.deliveryAllowed;
			this.dev(`delivery - zone ${JSON.stringify(this.deliveryZone)}`);
			if (this.deliveryZone.menuItemKey) {
				this.dev('delivery - menuItemKey');
				const deliveryFeeIdx = this.check.items.findIndex((i) => i.deliveryFee === true);
				if (deliveryFeeIdx !== -1) {
					this.check.items.splice(deliveryFeeIdx, 1);
				}
				const menuItem = this.ooMenuItems.find((i) => i.menuItemKey === this.deliveryZone.menuItemKey);
				if (menuItem && !menuItem.online) {
					menuItem.displayName = 'Delivery Fee';
					menuItem.priceNumber = 1;
					menuItem.taxable = true;
				}
				this.dev(`delivery - menuItem ${menuItem.menuItemKey}`);
				const checkItem = this.menuItemToCheckItem(menuItem, 1, this.deliveryZone.deliveryFee, true);
				this.dev(`delivery - checkItem ${checkItem.displayName}`);
				this.check.items.push(checkItem);
				this.updateCheckTotals(this.check);
				this.dev(`delivery - updateCheckTotals`);
			}
			this.deliveryAllowed = true;
			this.dev('delivery allowed');
			return true;
		} else {
			this.deliveryAllowed = false;
			this.dev('Not in zone');
			return false;
		}
	}

	async getAlias(alias: string) {
		try {
			const resp = await this.focuslink.aliasGet(alias);
			const a = new OOAliasUrl(resp);
			this.venueKey = a.venueKey;
			a.menuKey ? (this.query.menuKey = a.menuKey) : undefined;
		} catch (error) {
			this.app.msgSvc.add({ severity: 'error', summary: 'Oops!', detail: `Venue not found` });
			this.error = `Venue not found for alias.`;
		}
	}

	getCheckItemCount(check: OOCheck) {
		if (check && check.items) {
			let totalItemQuantity = 0;
			check.items.forEach((item) => (totalItemQuantity += item.qty));
			return totalItemQuantity;
		}
		return 0;
	}

	getCheckItemTotal(item: OOCheckItem) {
		let price = item.price;
		if (item.modifiers) {
			for (const mod of item.modifiers) {
				price = price + mod.price;
			}
		}
		price = price * item.qty;
		return price;
	}

	getPriceNumberName(menuItemKey, priceNumber) {
		const menuItem = this.ooMenuItems.find((mi) => mi.menuItemKey === menuItemKey);
		let priceLevel = this.ooMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === menuItem.priceLevel);
		if (this.linkedMenuConfig) {
			priceLevel = this.linkedMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === menuItem.priceLevel);
		}
		const name = priceLevel.priceDisplayName1;
		switch (priceNumber) {
			case 1: {
				return priceLevel.priceDisplayName1;
			}
			case 2: {
				return priceLevel.priceDisplayName2;
			}
			case 3: {
				return priceLevel.priceDisplayName3;
			}
			case 4: {
				return priceLevel.priceDisplayName4;
			}
			case 5: {
				return priceLevel.priceDisplayName5;
			}
			case 6: {
				return priceLevel.priceDisplayName6;
			}
		}
	}

	getCardDisplayName(card) {
		return String(card).replace(/\d(?=\d{4})/g, 'x');
	}

	async getLeadTime(check: OOCheck, orderTypeKey: number, futureOrderTime?: string) {
		this.orderThrottleRule = await this.focuslink.getLeadTime(this.venueKey, orderTypeKey, check.total, futureOrderTime || undefined);
		let orderLeadTime = this.venue.orderLeadTime;

		this.dueDateTimeMessage = null;
		this.sbCart.loading = true;
		try {
			this.dev(`OT Lead Time = ${this.orderType.orderLeadTime}`);

			//Order type lead time is greater than throttle. So order lead time is based on order type lead time
			if (this.orderThrottleRule) {
				this.dev(`orderThrottleRule = ${this.orderThrottleRule}`);
				if (this.orderThrottleRule.throttleOrderRevenue) {
					this.dev(`LeadTime - ThrottleRevenue: ${this.orderThrottleRule.throttleOrderMinutes}`);
					orderLeadTime += this.orderThrottleRule.throttleOrderMinutes;
					this.dev(`New Lead Time: ${orderLeadTime}`);
				}
				if (this.orderThrottleRule.throttleOrderCount) {
					this.dev(`LeadTime - ThrottleCount: ${this.orderThrottleRule.throttleOrderMinutes}`);
					orderLeadTime = this.orderThrottleRule.throttleOrderMinutes;
					this.dev(`New Lead Time: ${orderLeadTime}`);
				}
			} else {
				if (this.orderType.orderLeadTime) {
					this.dev(`LeadTime - OrderType: ${this.orderType.orderLeadTime}`);
					orderLeadTime += this.orderType.orderLeadTime;
					this.dev(`New Lead Time: ${orderLeadTime}`);
				} else {
					this.dev(`LeadTime - Venue Default: ${this.venue.orderLeadTime}`);
					this.dev(`New Lead Time: ${orderLeadTime}`);
				}
			}
			this.check.leadTime = orderLeadTime;

			const dueDateTime = moment().add(check.leadTime, 'minutes');
			this.dueDateTimeMessage = dueDateTime.format('LLL');
			if (dueDateTime.dayOfYear() === moment().dayOfYear()) {
				this.dueDateTimeMessage = `Today at ${dueDateTime.format('LT')}`;
			}
			if (dueDateTime.dayOfYear() === moment().dayOfYear() + 1) {
				this.dueDateTimeMessage = `Tomorrow at ${dueDateTime.format('LT')}`;
			}
			this.sbCart.loading = false;
		} catch (error) {
			this.dev(`${error}`);
			this.sbCart.loading = false;
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Error getting order lead time',
				key: 'sidebar',
			});
		}
	}

	async applyGiftCard(giftProcessed: GiftProcessedDTO) {
		this.giftAccount = giftProcessed.accountNumber;
		this.giftAmount = giftProcessed.appliedAmount;
		this.giftBalanceAmount = giftProcessed.balanceAmount;
		this.check.total = +(((this.check.total - giftProcessed.appliedAmount) * 100) / 100).toFixed(2);
		this.continueMessage = 'Submit Order';
		this.checkoutStep = 'orderReview';

		if (this.check.total === 0) {
			this.allowSubmit = true;
		} else {
			if (this.venue.ccProcessor === CCProcessors.SHIFT4 || this.venue.ccProcessor === CCProcessors.FOCUSPAYADYEN) {
				this.i4goCardOther = true;
			}
		}
	}

	async handleAddressSelect(event) {
		if (event === 'manual' && this.check.shipping.address1 && this.check.shipping.city && this.check.shipping.state && this.check.shipping.postalCode) {
			const resp = await this.focuslink.postAddressCheck(this.venueKey, this.check.shipping);
			this.addressGeo.latitude = resp[0].geometry.location.lat;
			this.addressGeo.longitude = resp[0].geometry.location.lng;
		} else {
			this.addressAutoCompleteValue = event.formattedAddress;
			this.check = AddressModel.addressToCheck(event, this.check);
			this.addressGeo = new AddressModel(event);
		}
		if (this.orderType.OOOrderTypeDeliveryZone?.length > 0) {
			this.evaluateDeliveryZone();
		}
	}

	async init() {
		this.loading = true;
		this.googleAnalytics.init('G-RT9EJ29S29', 'online-order');

		this.app.initProduct(this.venueKey, FocusLinkProduct.OnlineOrder, ProductUseFunction.STARTED).then((data) => {
			this.useKey = data;
			this.onlineOrderService.sessionId = this.useKey;
		});

		if (this.venueAlias && !this.venueKey) {
			await this.getAlias(this.venueAlias);
		}
		if (await this.storage.check('fcck')) {
			this.customerGet(await this.storage.get('fcck'));
		} else {
			this.googleAnalytics.eventEmitter('init_order', 'onlineOrder', 'init', undefined, this.venueKey);
		}

		if (this.query.kiosk) {
			this.kioskDeviceId = await this.storage.get('kioskDeviceId');
			this.kioskMode = true;
		}

		await this.initVenue();
		await this.initCheck();
		await this.reset();

		this.loading = false;

		if (this.query.canvasMenuItem) {
			console.log(`Loading ${this.query.canvasMenuItem}`);
			const queryCanvas = this.ooCanvasesOnline.find((i) => i.canvasKey === +this.query.canvasMenuItem.split('_')[0]);
			if (queryCanvas) {
				const queryItem = queryCanvas.menuItems.find((i) => i.menuItemKey === +this.query.canvasMenuItem.split('_')[1]);

				if (queryItem) {
					console.log(`Direct to ${queryItem.displayName || queryItem.ooMenuItem?.name}`);
					this.openMenuItemModal(queryItem, this.menuItemModalTemplate);
				}
			}
		}
		this.duration.pageLoaded = this.app.references.duration(this.duration.start);
		console.log(`Welcome to ${this.venue.name}. PL ${this.duration.pageLoaded}`);
	}

	async initCheck() {
		let checkKey: string;
		const localCheckKey: any = await this.storage.get(`${this.venueKey}-${this.query.table}`);
		if (localCheckKey) {
			checkKey = localCheckKey;
		}

		if (this.query.checkKey) {
			checkKey = this.query.checkKey;
		}

		if (this.query.newcheck !== 'true' && checkKey) {
			let savedCheck: CheckDto;
			try {
				savedCheck = await this.focuslink.getCheck(this.venueKey, checkKey);
			} catch (error) {}

			if (savedCheck && savedCheck.seats && savedCheck.seats[0] && savedCheck.open && savedCheck.status !== CheckStatus.INPROCESS) {
				this.clearCheck();

				const seat = savedCheck.seats[0];
				if (seat.open) {
					this.dev('Restoring check: ' + checkKey);
					if (savedCheck.linkKey) {
						await this.initLinkKey(savedCheck.linkKey);
					}
					this.savedCheck = savedCheck;
					this.check.checkKey = checkKey;
					seat.items.forEach((item) => {
						this.check.items.push(this.checkItemDtoToCheckItem(item));
					});
					this.check.verified = true;
					this.check.status = this.savedCheck.status;
					this.check.subtotal = this.savedCheck.subtotal;
					this.check.orderTypeFee = this.savedCheck.orderTypeChargeTotal;
					this.check.creditCardPassAlongFee = this.savedCheck.creditCardPassAlongFee;
					this.check.tax = this.savedCheck.taxtotal;
					this.check.tip = 0;
					this.check.remainingBalance = this.savedCheck.remainingBalance;

					this.paymentToken = this.savedCheck.seats[0].tabToken;
					this.check.tipPercent = this.savedCheck.seats[0].tabTipPercent;

					this.check.total = +(Math.round((this.savedCheck.total + this.check.tip) * 100) / 100).toFixed(2);

					this.updateCheckTotals(this.check);
					this.onlineOrderService.subscribeToCheckKey(this.check.checkKey);
				}
			} else {
				this.clearCheck();
				this.updateCheckTotals(this.check);
			}
		} else {
			this.clearCheck();
			this.updateCheckTotals(this.check);
		}

		if (this.query.table) {
			await this.storage.set(`${this.venueKey}-${this.query.table}`, this.check.checkKey);
		}

		if (this.link) {
			this.link.shareUrl = `https://app.focuspos.com/${this.link.venueKey}?linkKey=${this.link.key}&checkKey=${this.check.checkKey}`;
		}

		this.onlineOrderService.orderRefreshDateTime.subscribe((data) => {
			if (data) {
				this.syncOrderWithcloud(this.onlineOrderService.order.value);
			}
		});
	}

	async initCustomer() {
		this.dev('init-customer');
		if (await this.storage.check(OnlineCustomerCode.ONLINECUSTOMER)) {
			this.dev('Restoring customer');
			this.onlineCustomer = await this.storage.get(OnlineCustomerCode.ONLINECUSTOMER);
			this.dev(`CustomerKey: ${this.onlineCustomer.key}`);
		} else {
			this.dev('No customer saved');
		}
	}

	async initLinkKey(linkKey) {
		if (!this.query.linkKey) this.query.linkKey = linkKey;

		const link = this.venue.ooLinks.find((l) => l.key === this.query.linkKey);
		if (link) {
			this.link = link;

			this.dev(link);
			console.log('Restored previous link experience');
			this.query.orderType = link.orderType;

			this.query.menuKey = link.menuKey;
			if (this.query.orderType) {
				const orderType = this.venue.ooOrderTypes.find((ot) => ot.key === this.query.orderType);
				if (orderType && (orderType.atTable || orderType.useLinkKeyTable)) {
					this.query.table = link.id;
					if (orderType.ignoreOOEnabledTime) {
						this.query.force = true;
					}
				}
			}
		} else {
			console.log(`linkKey ${linkKey} is invalid or cannot be found`);
		}
		return;
	}

	initSidebar() {
		if (this.check.total === 0) {
			this.allowSubmit = false;
		}
	}

	async initVenue() {
		console.log(`Launch ${this.venueKey} - V${this.app.env.version}`);
		try {
			const start = new Date();
			let promiseList: any[] = [
				this.focuslink.getOOVenue(this.venueKey).then((data) => (this.venue = data)),
				this.focuslink.timeRangeGetAll(this.venueKey).then((data) => (this.timeRangeList = data)),
				this.focuslink.getOOCanvases(this.venueKey, false).then((data) => (this.ooCanvases = data)),
				this.focuslink
					.getOOMenuItems(this.venueKey, true)
					.then((data) => (this.ooMenuItems = data))
					.catch((error) => {
						console.log(error);
					}),
				// this.focuslink
				// 	.onlineOrderGetMenuSet(this.venueKey)
				// 	.then((data) => ((this.ooCanvases = data.ooCanvases), (this.ooMenuItems = data.ooMenuItems))),
				this.focuslink.getOOMenuConfig(this.venueKey).then((data) => (this.ooMenuConfig = data)),
			];

			await Promise.all(promiseList);

			this.venueUpdateSubscription();

			this.googleAnalytics.setVenue(this.venue.venueKey, this.venue.name);

			this.venueService.ooVenue = this.venue;
			if (this.venue) {
				this.titleService.setTitle(`${this.venue.name} Online Ordering`);
			}

			if (environment.production && this.venueKey === 15201 && this.kioskMode) {
				LogRocket.init('e5d7fz/focuslink', {
					release: this.app.env.version,
				});
				LogRocket.identify(this.venueKey.toString());
			}

			if (this.kioskMode) {
				if (this.kioskDeviceId) {
					await this.kioskPaymentService.initKiosk(this.venueKey);
					console.log(`Kiosk service initiated successfully. Awaiting WS traffic`);
				} else {
					console.log(`Kiosk deviceId not found.`);
				}
			}

			this.venue.styles.canvasShowItemDescription = true;

			this.venue.ooOrderTypes = this.venue.ooOrderTypes.filter((ot) => !ot.deleted);
			this.venueService.ooOrderTypes = this.venue.ooOrderTypes;
			this.venueService.subscriptionOOorderTypes.next(this.venueService.ooOrderTypes);
			this.linkedVenue = this.venue.linkedVenueKey ? await this.focuslink.getOOVenue(this.venue.linkedVenueKey) : null;
			if (this.linkedVenue) {
				this.ooCanvases = await this.focuslink.getOOCanvases(this.venue.linkedVenueKey || this.venueKey, true);
				let menuItemKeyList = [];
				this.ooCanvases.forEach((canvas) => {
					if (canvas.menuItems.length > 0) {
						menuItemKeyList = menuItemKeyList.concat(canvas.menuItems.map((item) => item.menuItemKey));
					}
				});

				menuItemKeyList = Array.from(new Set(menuItemKeyList));
				menuItemKeyList.sort();
				this.ooMenuItems = await this.focuslink.getOOMenuItemsOnlineOnlyByKey(this.venue.linkedVenueKey, menuItemKeyList);
				this.linkedMenuConfig = this.venue.linkedVenueKey ? await this.focuslink.getOOMenuConfig(this.venue.linkedVenueKey) : null;
			}

			if (this.venue.orderActive && this.venue.posStatus === 0) {
				this.alert = "Sorry, we're currently experiencing technical difficulties and working to fix the problem.";
				this.allowOrder = false;
			} else if (!this.venue.orderActive) {
				this.alert = "Sorry, we're currently not accepting orders. Please try again later.";
				this.allowOrder = false;
			} else {
				this.alert = null;
				//this.query.mode = null;
				this.allowOrder = true;
			}
			setInterval(async () => {
				this.venue = await this.focuslink.getOOVenue(this.venueKey);
				this.venue.ooOrderTypes = this.venue.ooOrderTypes.filter((ot) => !ot.deleted);
				this.linkedVenue = this.venue.linkedVenueKey ? await this.focuslink.getOOVenue(this.venue.linkedVenueKey) : null;
				if (this.venue.orderActive && this.venue.posStatus === 0) {
					this.alert = "Sorry, we're currently experiencing technical difficulties and working to fix the problem.";
					this.allowOrder = false;
				} else if (!this.venue.orderActive) {
					this.alert = "Sorry, we're currently not accepting orders. Please try again later.";
					this.allowOrder = false;
				} else {
					this.alert = null;
					this.allowOrder = true;
				}
			}, 30000);

			if (this.query.linkKey) {
				await this.initLinkKey(this.query.linkKey);
			}

			this.initCustomer();

			// this.focuslink.getOOMenuItems(this.venue.linkedVenueKey || this.venueKey, true, menuItemKeyList).then((data) => (this.ooMenuItems = data))

			this.timeRangeActive = this.activeTimeRanges();
			this.duration.datafetched = this.app.references.duration(this.duration.start);
			this.buildMenu();

			this.venueService.buildFutureOrderTimeSlots();
			this.canvasSelected = this.ooCanvasesOnline[0];
			this.loading = false;

			if (this.venue.displayPromo) {
				this.openPromo(this.promoModalTemplate);
			}
		} catch (error) {
			this.loading = false;
			this.error = 'Oops! Something went wrong.';
			console.error(error);
		}
	}

	async kioskStoreCredentials(credentials: { licenseKey: string; licenseSecret: string }) {
		this.kioskPaymentService.deviceService.storeLicense(credentials.licenseKey, credentials.licenseSecret);
		this.kioskDeviceId = credentials.licenseKey;
		this.kioskPaymentService.initKiosk(this.venueKey);
		console.log(`Kiosk service initiated successfully. Awaiting WS traffic`);
		return;
	}

	venueUpdateSubscription() {
		this.venueService.venueSocketConnect(this.venueKey);
		this.venueService.venueMessage(this.venueKey);
		this.venueService.subscriptionOOmenuItems.subscribe((updatedItems) => {
			this.ooCanvasesOnline?.forEach((onlineCanvas) => {
				onlineCanvas.menuItems.forEach((mi) => {
					const menuItem = updatedItems.find((i) => i.menuItemKey === mi.menuItemKey);
					if (menuItem) {
						if (menuItem.price !== mi.price) mi.price = menuItem.price;
						for (let i = 2; i < 7; i++) {
							if (menuItem[`price${i}`] !== mi[`price${i}`]) mi[`price${i}`] = menuItem[`price${i}`];
						}
						if (menuItem.outOfStock !== mi.ooMenuItem.outOfStock) mi.ooMenuItem.outOfStock = menuItem.outOfStock;
					}
				});
			});
		});
	}

	async login(key: string | number, password: string) {
		this.loggingIn = true;
		try {
			await this.focuslink.verifyCustomerPassword(key, btoa(password));
			this.customer = await this.focuslink.getCustomer(key);
			this.customerCards = this.customer.creditCards.map((c) => ({
				label: `${this.getCardType(c.type)} - ${c.last4}`,
				value: c,
			}));
			this.customerCards.push({
				label: 'New Card',
				value: null,
			});
			this.loggingIn = false;
			this.password = null;
			this.passwordConfirm = null;
			this.customerEmail = null;
			this.customerCardToken = this.customerCards[0].value;
			this.panelLogin.hide();
		} catch (error) {
			this.loggingIn = false;
			this.password = null;
			this.passwordConfirm = null;
			this.customerEmail = null;
			this.customerCards = null;
			this.app.msgSvc.add({ severity: 'error', detail: 'Unauthorized' });
		}
	}

	logout() {
		this.password = null;
		this.passwordConfirm = null;
		this.customerEmail = null;
		this.customerCards = null;
		this.customer = null;
	}

	menuItemToCheckItem(menuItem: OOMenuItem, qty: number, priceOverride?: number, deliveryFee?: boolean, existingItemUUID?: string) {
		const checkItem = new OOCheckItem();

		checkItem.key = menuItem.menuItemKey;
		checkItem.canvasKey = deliveryFee ? 1 : menuItem['canvasKey'] || this.canvasSelected.canvasKey;
		checkItem.name = menuItem.name;
		checkItem.displayName = menuItem.displayName;
		checkItem.qty = qty;
		checkItem.price = priceOverride ? +priceOverride : this.getMenuItemPrice(menuItem);
		checkItem.modifiers = [];
		checkItem.taxable = menuItem.taxable;
		checkItem.priceNumber = menuItem.priceNumber;
		checkItem.priceNumberName = menuItem.priceNumberName;
		checkItem.deliveryFee = deliveryFee;
		checkItem.kitchenComment = deliveryFee ? true : checkItem.kitchenComment;
		checkItem.guestCheckName = deliveryFee ? 'Delivery Fee' : checkItem.guestCheckName;
		checkItem.unsent = true;
		checkItem.uuid = existingItemUUID || uuid.v4();

		!deliveryFee &&
			this.menuItemModifiers &&
			Object.keys(this.menuItemModifiers).forEach((canvasIdx) => {
				Object.keys(this.menuItemModifiers[canvasIdx]).forEach((menuItemIdx) => {
					this.menuItemModifiers[canvasIdx][menuItemIdx].forEach((value) => {
						checkItem.modifiers.push({
							key: value.menuItem.menuItemKey,
							name: value.menuItem.name,
							displayName: value.menuItem.displayName,
							price: this.getMenuItemPrice(value.menuItem),
							taxable: value.menuItem.taxable,
							priceNumber: value.menuItem.priceNumber,
							priceNumberName: value.menuItem.priceNumberName,
							level: 1,
							canvasIdx: value.canvasIdx,
							menuItemIdx: value.menuItemIdx,
						});
						Object.keys(this.menuItemSubModifiers[canvasIdx][menuItemIdx]).forEach((modCanvasIdx) => {
							this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].forEach((value) => {
								checkItem.modifiers.push({
									key: value.menuItem.menuItemKey,
									name: value.menuItem.name,
									displayName: value.menuItem.displayName,
									price: this.getMenuItemPrice(value.menuItem),
									taxable: value.menuItem.taxable,
									priceNumber: value.menuItem.priceNumber,
									priceNumberName: value.menuItem.priceNumberName,
									level: 2,
									canvasIdx: value.canvasIdx,
									menuItemIdx: value.menuItemIdx,
									modCanvasIdx: value.modCanvasIdx,
									modMenuItemIdx: value.modMenuItemIdx,
								});
							});
						});
					});
				});
			});

		return checkItem;
	}

	removeItemFromCheck(idx: number) {
		const item = this.check.items[idx];

		this.check.items.splice(idx, 1);
	}

	async openMenuItemModal(item: any, templateRef: TemplateRef<any>, checkItemIdx?: number, parentCanvasIndex?: number, menuItemIndex?: number) {
		if (this.query.mode === 'menu') {
			return;
		}

		if (item.sharedFromCanvasKey && item.sharedFromVenueKey && item.sharedFromMenuItemKey) {
			this.app.loading(true);
			try {
				const sharedItemMeta = await this.focuslink.menuItemGetSharedModifiers(
					this.venueKey,
					item.menuItemKey,
					item.sharedFromVenueKey,
					item.sharedFromMenuItemKey
				);
				if (sharedItemMeta?.menuItemCanvasList?.length > 0) {
					item.canvases = [];
					sharedItemMeta.menuItemCanvasList.forEach((smic) => {
						const originalCanvas = { ...smic };
						Object.assign(
							smic,
							sharedItemMeta.canvasList.find((i) => i.canvasKey === smic.canvasKey)
						);
						smic.online = originalCanvas.online;
						smic.menuItems?.forEach((mi) => {
							Object.assign(mi, mi.ooMenuItem);
							mi.canvases?.forEach((miCan) => {
								miCan.online = false;
							});
						});
					});
					item.canvases = sharedItemMeta.menuItemCanvasList;
					if (sharedItemMeta.canvasList?.length > 0) {
						sharedItemMeta.canvasList?.forEach((sharedCanvas) => {
							const canvas = this.ooCanvases.find((c) => c.canvasKey === sharedCanvas.canvasKey);
							if (!canvas) {
								this.ooCanvases.push(sharedCanvas);
							}
						});
					}
				}
			} catch (error) {
				await this.app.log(LogLevel.ERROR, 'shared-item-modifier', this.venueKey, error);
			}

			this.app.loading(false);
		}

		if (!this.canvasSelected && item.canvasKey) {
			this.canvasSelected = this.ooCanvases.find((i) => i.canvasKey === item.canvasKey);
		}

		const canvasSelectedIdx = this.ooCanvases.findIndex((i) => i.canvasKey === item.canvasKey);
		const menuItemIdx = this.ooCanvases[canvasSelectedIdx].menuItems.findIndex((i) => i.menuItemKey === item.menuItemKey);

		this.menuItemModifiers = null;
		this.menuItemSubModifiers = null;
		this.checkItemIdx = checkItemIdx;
		this.showModal = false;
		this.showModifiers = false;
		this.showPriceLevels = false;
		this.priceLevels = [];
		const priceNumber = item.priceNumber;
		let modifiers = item.modifiers;
		if (checkItemIdx >= 0) {
			this.canvasSelected = this.ooCanvasesOnline.find((i) => i.canvasKey === item.canvasKey);
			this.menuItemQty = item.qty;
			const menuItemComment1 = item.modifiers.find(
				(m) => m.key === (this.linkedMenuConfig ? this.linkedMenuConfig.commentsMenuId : this.ooMenuConfig.commentsMenuId)
			);
			this.menuItemComment1 = menuItemComment1 && menuItemComment1.name;
			const menuItemComment2 = item.modifiers.find(
				(m) => m.key === (this.linkedMenuConfig ? this.linkedMenuConfig.exceptionMenuId : this.ooMenuConfig.exceptionMenuId)
			);
			this.menuItemComment2 = menuItemComment2 && menuItemComment2.name;
			const canvas = this.ooCanvasesOnline.find((c) => c.canvasKey === item.canvasKey);
			const menuItem = canvas.menuItems.find((mi) => mi.menuItemKey === item.key);
			item = menuItem;
		} else {
			this.menuItemQty = 1;
			this.menuItemComment1 = null;
			this.menuItemComment2 = null;
		}

		this.menuItemSelected = { ...item };
		this.menuItemTotal = this.getMenuItemPrice(this.menuItemSelected);

		if (this.menuItemSelected.priceLevel > 0 && this.menuItemSelected.priceLevelEnforced) {
			let priceLevel = this.ooMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === this.menuItemSelected.priceLevel);
			if (this.linkedMenuConfig) {
				priceLevel = this.linkedMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === this.menuItemSelected.priceLevel);
			}
			if (priceLevel) {
				if (priceLevel.priceName1) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName1} ($${this.menuItemSelected.price})`,
						value: 1,
					});
				}
				if (priceLevel.priceName2) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName2} ($${this.menuItemSelected.price2})`,
						value: 2,
					});
				}
				if (priceLevel.priceName3) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName3} ($${this.menuItemSelected.price3})`,
						value: 3,
					});
				}
				if (priceLevel.priceName4) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName4} ($${this.menuItemSelected.price4})`,
						value: 4,
					});
				}
				if (priceLevel.priceName5) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName5} ($${this.menuItemSelected.price5})`,
						value: 5,
					});
				}
				if (priceLevel.priceName6) {
					this.priceLevels.push({
						label: `${priceLevel.priceDisplayName6} ($${this.menuItemSelected.price6})`,
						value: 6,
					});
				}
			}
			if (this.priceLevels.length > 0) {
				this.selectPriceNumber(priceNumber || this.priceLevels[0].value, this.menuItemSelected);
				this.showPriceLevels = true;
			}
		}
		if (this.menuItemSelected.canvases && this.menuItemSelected.canvases.filter((c) => c.online).length > 0) {
			this.buildCanvasOptions(this.menuItemSelected.canvases, canvasSelectedIdx, menuItemIdx);
			if (modifiers) {
				modifiers.forEach((m) => {
					if (m.level === 1) {
						const option = this.menuItemSelected.canvases[m.canvasIdx].options[m.menuItemIdx].value;
						this.menuItemModifiers[m.canvasIdx][m.menuItemIdx].push(option);
					}
					if (m.level === 2) {
						const option =
							this.menuItemSelected.canvases[m.canvasIdx].options[m.menuItemIdx].value.menuItem.canvases[m.modCanvasIdx].options[m.modMenuItemIdx]
								.value;
						this.menuItemSubModifiers[m.canvasIdx][m.menuItemIdx][m.modCanvasIdx].push(option);
					}
				});
			}
			this.showModifiers = true;
		}
		if (!this.menuItemSelected.priceLevel && this.menuItemSelected.canvases?.length === 0 && item.quickAdd && checkItemIdx === undefined) {
			this.addMenuItem(this.menuItemSelected, 1, undefined, true);
			// return;
		} else {
			this.modalRef = this.app.modal.open(templateRef, {
				centered: true,
				backdrop: 'static',
				animation: true,
			});
		}

		this.dev(this.menuItemSelected);

		setTimeout(() => {
			this.showModal = true;
			this.validateMenuItem();
		});

		if (
			this.menuItemSelected.canvases?.some((modCanvas) => {
				return modCanvas.options.some((i) => i.value?.preselected);
			})
		) {
			this.menuItemSelected.canvases.forEach((modifierCanvas, modifierCanvasIdx) => {
				if (modifierCanvas.options.some((modCanvasOption) => modCanvasOption.value?.preselected)) {
					const modifierOptionIndex = modifierCanvas.options.findIndex((modCanvasOption) => modCanvasOption.value?.preselected);
					if (modifierCanvasIdx !== -1) {
						this.buildCanvasOptionsPreselect(modifierCanvas, modifierCanvasIdx, modifierOptionIndex);
					}
				}
			});
		}
	}

	async orderClose() {
		this.saving = true;
		try {
			this.dev('Order close');
			const orderRes = await this.focuslink.orderClose(this.venueKey, this.check.checkKey);
			this.saving = false;
			if (!orderRes.open) {
				let amount = orderRes.seats[0].payments[0].amount;
				let tip = orderRes.seats[0].payments[0].tip;
				if (tip) {
					amount = amount - tip;
				}
				this.paymentResult = {
					amount: amount,
					tip: tip,
					email: orderRes.email,
				};
				let token = btoa(`${this.check.checkKey}#0`);
				this.receiptUrl = `https://pay.focuspos.com/${token}`;
				this.continueMessage = 'Start New Order';
				this.checkoutStep = 'paymentComplete';
				this.orderStatusMessage = 'Payment Complete!';
				this.app.msgSvc.clear();
			} else {
				this.app.msgSvc.add({
					severity: 'error',
					detail: 'Check payment incomplete',
					key: 'sidebar',
				});
			}
		} catch (error) {
			console.error(error);
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Error closing order',
				key: 'sidebar',
			});
			this.saving = false;
		}
	}

	async orderPrePayment() {
		this.saving = true;
		await this.initCheck();
		this.saving = false;
		this.confirmationService.confirm({
			header: 'Check Total: $' + this.savedCheck.total,
			message: 'Ready to pay and close this check?',
			accept: async () => {
				await this.orderClose();
			},
		});
	}

	searchForItems(event) {
		this.searchTerm = this.searchItemValue.nativeElement.value;
		if (this.searchTerm === '') {
			this.searchTerm = undefined;
			this.searchItemResults = undefined;
		}

		let searchResults = [];
		if (this.searchItemResults?.length > 0) {
			searchResults = this.searchItemResults?.filter(
				(item) =>
					item.description?.toLowerCase().includes(this.searchTerm?.toLowerCase()) ||
					item.displayName?.toLowerCase().includes(this.searchTerm?.toLowerCase()) ||
					item['name']?.toLowerCase().includes(this.searchTerm?.toLowerCase())
			);
		} else {
			searchResults = this.canvasMenuItems.filter(
				(item) =>
					item.description?.toLowerCase().includes(this.searchTerm?.toLowerCase()) ||
					item.displayName?.toLowerCase().includes(this.searchTerm?.toLowerCase()) ||
					item['name']?.toLowerCase().includes(this.searchTerm?.toLowerCase())
			);
		}

		if (searchResults.length > 0) {
			this.searchItemResults = searchResults;
		}
		return;
	}

	searchForItemByTag(eventValue: string[]) {
		let searchResults = [];
		if (eventValue.length === 0) {
			this.searchItemResults = searchResults;
			return;
		}

		eventValue.forEach((searchTagKey) => {
			searchResults = searchResults.concat(
				this.canvasMenuItemsWithTags.filter((itm) => {
					if (itm['OOMenuItemTags'].some((itmTag) => itmTag.tagKey === searchTagKey)) {
						return itm;
					}
				})
			);
		});
		if (searchResults.length > 0) {
			this.searchItemResults = searchResults;
		}
		return;
	}

	selectModifierFromDropdown(canvasIdx, event, canvas: OOCanvas) {
		this.menuItemModifiers[canvasIdx][event.itemValue.menuItemIdx] = event.itemValue;
		this.selectModifier(canvasIdx, event.itemValue.menuItemIdx, canvas, event.itemValue.menuItemIdx, event);
	}

	selectModifier(canvasIdx: number, menuItemIdx: number, canvas: OOCanvas, value, event) {
		console.log(this.menuItemModifiers);
		console.log(canvas.max);
		console.log(event.length);
		if (event.length > 0) {
			console.log(`event.length > 0`);
			if (canvas.max === 1) {
				Object.keys(this.menuItemModifiers[canvasIdx]).forEach((menuItemIdx) => {
					this.menuItemModifiers[canvasIdx][menuItemIdx].length = 0;
					this.menuItemModifiers[canvasIdx][menuItemIdx] = [...this.menuItemModifiers[canvasIdx][menuItemIdx]];
					Object.keys(this.menuItemSubModifiers[canvasIdx][menuItemIdx]).forEach((modCanvasIdx) => {
						this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].length = 0;
						this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx] = [...this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx]];
					});
				});
				this.menuItemModifiers[canvasIdx][menuItemIdx].push(value);
				this.menuItemModifiers[canvasIdx][menuItemIdx] = [...this.menuItemModifiers[canvasIdx][menuItemIdx]];
			}

			if (canvas.max > 1) {
				let count = 0;
				Object.keys(this.menuItemModifiers[canvasIdx]).forEach((menuItemIdx) => {
					count = count + this.menuItemModifiers[canvasIdx][menuItemIdx].length;
				});
				if (count > canvas.max) {
					const itemIdx = this.menuItemModifiers[canvasIdx][menuItemIdx].findIndex((i) => i.menuItem.menuItemKey === value.menuItem.menuItemKey);
					this.menuItemModifiers[canvasIdx][menuItemIdx].splice(itemIdx, 1);
					this.menuItemModifiers[canvasIdx][menuItemIdx] = [...this.menuItemModifiers[canvasIdx][menuItemIdx]];
				}
			}
		}
		this.updateMenuItemTotal();
		this.updateCheckTotals(this.check);
		this.validateMenuItem();
	}

	async selectOrderType(key: number) {
		this.dev(`selectOrderType - OTKey: ${key}`);

		const acceptingOrders: boolean = this.acceptingOrders(this.venue);
		const deliveryFeeIdx = this.check.items.findIndex((i) => i.deliveryFee === true);
		if (deliveryFeeIdx !== -1) {
			this.check.items.splice(deliveryFeeIdx, 1);
			this.updateCheckTotals(this.check);
		}
		this.futureOrderOptions = [];
		if (acceptingOrders) {
			this.futureOrderOptions.push({ label: 'Order for ASAP', value: 'now' });
		}
		if (this.venue.futureOrderMode > 0) {
			this.futureOrderOptions.push({ label: 'Order for Later', value: 'later' });
		}

		if (this.check.futureOrder !== 'later') {
			this.selectFutureOrderDate(this.futureOrderMinDate);
			this.check.futureOrder = this.futureOrderOptions[0] && this.futureOrderOptions[0].value;
		} else {
			this.selectFutureOrderDate(this.futureOrderDate);
		}

		if (this.venue.futureOrderMode === 1) {
			this.futureOrderMaxDate = this.futureOrderMinDate;
		}
		if (this.venue.futureOrderMode === 2) {
			this.futureOrderMaxDate = moment().add(this.venue.futureOrderThreshold, 'days').toDate();
		}

		if (key >= 0) {
			this.orderType = this.venue.ooOrderTypes.find((ot) => ot.key === key);
		}

		let allowOrder = true;
		if (this.orderType) {
			if (!this.orderType.storeCustomerData) {
				this.onlineCustomer = undefined;
			}

			if (!acceptingOrders && !this.orderType.futureOrders) {
				this.dev(`venue not accepting orders: acceptingOrders = false && futureOrders = false`);

				if (moment().tz(this.venue.timezone).isBefore(this.orderAcceptanceStartTime.tz(this.venue.timezone))) {
					this.continueMessage = `Not accepting orders until ${this.orderAcceptanceStartTime.tz(this.venue.timezone).format('LT')}`;
				} else {
					this.continueMessage = 'Not currently accepting orders';
				}

				allowOrder = false;
			}
			if (!acceptingOrders && this.orderType.ignoreOOEnabledTime) {
				allowOrder = true;
			}

			if (this.orderType.minimumOrderAmount && this.orderType.minimumOrderAmount > 0 && this.orderType.minimumOrderAmount > this.check.total) {
				this.orderType.orderTypeNote = `Your order does not reach the minimum of $${this.orderType.minimumOrderAmount} for ${this.orderType.displayName}.`;
				this.dev(`venue not accepting orders: order minimum not reached`);
				allowOrder = false;
			}
			if (this.orderType.maximumOrderAmount && this.orderType.maximumOrderAmount > 0 && this.orderType.maximumOrderAmount < this.check.total) {
				this.orderType.orderTypeNote = `Sorry, your order exceeds the maximum amount ($${this.orderType.maximumOrderAmount}) allowed for ${this.orderType.displayName}.`;
				this.dev(`venue not accepting orders: order maximum exceeded`);
				allowOrder = false;
			}
			if (this.orderType.promptAddress) {
				if (this.orderType.OOOrderTypeDeliveryZone?.length > 0) {
					if (this.check.shipping.address1 && this.check.shipping.city) {
						this.deliveryAllowed = await this.evaluateDeliveryZone();
					} else {
						this.deliveryAllowed = false;
					}
				}
			} else {
				this.deliveryAllowed = true;
			}
		} else {
			if (!acceptingOrders) {
				this.dev(`venue not accepting orders: acceptingOrders = false`);
				allowOrder = false;
			}
		}
		if (this.futureOrderOptions.length === 0) {
			this.dev(`venue not accepting orders: futureOrderOptions.length === 0`);
			allowOrder = false;
		}

		this.app.msgSvc.clear('sidebar');
		if (!allowOrder) {
			this.dev('Do not allow order');
			this.allowSubmit = false;
			this.app.msgSvc.add({
				severity: 'error',
				detail: this.orderType.orderTypeNote || 'Currently Not Accepting Orders',
				key: 'sidebar',
			});
			// this.continueMessage = 'Currently Not Accepting Orders';
			return 0;
		}

		await this.getLeadTime(this.check, this.orderType.key);
		this.orderType.orderTypeNote = undefined;
		return 1;
	}

	selectPriceNumber(priceNumber: number, menuItem: OOMenuItem) {
		menuItem.priceNumber = priceNumber;
		let priceLevel = this.ooMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === this.menuItemSelected.priceLevel);
		if (this.linkedMenuConfig) {
			priceLevel = this.linkedMenuConfig.priceLevels.find((pl) => pl.priceLevelKey === this.menuItemSelected.priceLevel);
		}
		switch (priceNumber) {
			case 1: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName1;
				break;
			}
			case 2: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName2;
				break;
			}
			case 3: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName3;
				break;
			}
			case 4: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName4;
				break;
			}
			case 5: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName5;
				break;
			}
			case 6: {
				this.menuItemSelected.priceNumberName = priceLevel.priceName6;
				break;
			}
		}
		this.updateMenuItemTotal();
		this.updateCheckTotals(this.check);
		this.validateMenuItem();
	}

	selectSubModifier(canvasIdx: number, menuItemIdx: number, modCanvasIdx: number, canvas: OOCanvas, value, event) {
		if (event.length > 0) {
			if (canvas.max === 1) {
				this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].length = 0;
				this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].push(value);
				this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx] = [...this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx]];
			}

			if (canvas.max > 1) {
				let count = 0;
				Object.keys(this.menuItemModifiers[canvasIdx]).forEach((menuItemIdx) => {
					count = count + this.menuItemModifiers[canvasIdx][menuItemIdx].length;
				});
				if (this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].length > canvas.max) {
					const itemIdx = this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].findIndex(
						(i) => i.menuItem.menuItemKey === value.menuItem.menuItemKey
					);
					this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].splice(itemIdx, 1);
					this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx] = [...this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx]];
				}
			}
		}
		this.updateMenuItemTotal();
		this.updateCheckTotals(this.check);
		this.validateMenuItem();
	}

	syncOrderWithcloud(cloudOrder: Order) {
		cloudOrder.seats?.forEach((seat) => {
			seat.items?.forEach((item) => {
				if (!this.check.items.some((i) => i.uuid === item.uuid)) {
					let ooCheckItem: OOCheckItem = new OOCheckItem();
					Object.assign(ooCheckItem, item);
					ooCheckItem.qty = +item.quantity;
					this.check.items.push(new OOCheckItem(ooCheckItem));
					this.app.msgSvc.add({
						severity: AppMessageSeverity.GREEN,
						summary: '',
						detail: `Added ${ooCheckItem.name} from another member of your party.`,
					});
				}
			});
		});

		this.updateCheckTotals(this.check);
		this.getCheckItemCount(this.check);
	}

	async tagFilterChange(event) {
		this.tagFilters = event.value;
	}

	updateCheckTotals(check) {
		check.newItems = false;
		check.subtotal = 0;
		check.orderTypeFee = this.check.orderTypeFee || 0;
		check.creditCardPassAlongFee = this.check.creditCardPassAlongFee || 0;

		check.tax = 0;
		check.items.forEach((item) => {
			if (!item.locked) {
				check.newItems = true;
			}
			check.subtotal += item.price * item.qty;
			if (item.taxable || item.locked) {
				check.tax += item.price * (this.venue.taxRate / 100) * item.qty;
			}
			if (item.modifiers) {
				for (const mod of item.modifiers) {
					check.subtotal += mod.price * item.qty;
					if (mod.taxable) {
						check.tax += mod.price * (this.venue.taxRate / 100) * item.qty;
					}
					if (mod.modifiers) {
						for (const submod of mod.modifiers) {
							check.subtotal += submod.price * item.qty;
							if (submod.taxable) {
								check.tax += submod.price * (this.venue.taxRate / 100) * item.qty;
							}
						}
					}
				}
			}
		});

		check.tip = this.check.tip || 0;
		if (this.check.tipPercent) {
			check.tip = check.subtotal * (this.check.tipPercent / 100);
		}

		if (this.validCheck) {
			check.orderTypeFee = this.validCheck.orderTypeFee || 0;
			check.creditCardPassAlongFee = this.validCheck.creditCardPassAlongFee || 0;
			check.tax = this.validCheck.taxTotal;
			check.total = this.validCheck.checkTotal + this.check.tip;
			this.check.verified = true;
		} else {
			check.total = check.subtotal + check.orderTypeFee + check.creditCardPassAlongFee + check.tax + check.tip;
			this.check.verified = false;
		}

		check.subtotal = +(Math.round(check.subtotal * 100) / 100).toFixed(2);
		check.orderTypeFee = +(Math.round(check.orderTypeFee * 100) / 100).toFixed(2);
		check.creditCardPassAlongFee = +(Math.round(check.creditCardPassAlongFee * 100) / 100).toFixed(2);
		check.tax = +(Math.round(check.tax * 100) / 100).toFixed(2);
		check.tip = +(Math.round(check.tip * 100) / 100).toFixed(2);
		check.total = +(Math.round(check.total * 100) / 100).toFixed(2);

		if (this.orderType) {
			if (!this.orderType.atTable) {
				this.tipOptions = [
					{ label: 'None', value: 0 },
					{
						label: this.orderType.tip1 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip1),
						value: 1,
					},
					{
						label: this.orderType.tip2 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip2),
						value: 2,
					},
					{
						label: this.orderType.tip3 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip3),
						value: 3,
					},
					{ label: 'Custom', value: 4 },
				];
			} else {
				this.tipOptions = [
					{ label: 'None', value: 0 },
					{
						label: this.orderType.tip1 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip1),
						value: 1,
					},
					{
						label: this.orderType.tip2 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip2),
						value: 2,
					},
					{
						label: this.orderType.tip3 * 100 + '% - $' + this.calcTip(this.check.subtotal, this.orderType.tip3),
						value: 3,
					},
				];
			}
		}
	}

	async updateOrder(order: Order) {
		this.saving = true;
		try {
			this.dev('Updating order');
			const orderRes = await this.focuslink.updateOrder(this.venueKey, order.checkKey, order);
			this.saving = false;
			this.app.msgSvc.add({ severity: 'success', detail: 'Items submitted!' });
			this.sbCart.close();
			await this.reset(true);
		} catch (error) {
			console.error(error);
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Error updating order',
				key: 'sidebar',
			});
			this.saving = false;
		}
	}

	validateMenuItem() {
		this.menuItemSelected.valid = true;
		if (this.menuItemSelected.canvases) {
			this.menuItemSelected.canvases.forEach((modCanvas, canvasIdx) => {
				if (modCanvas.online && modCanvas.min > 0) {
					let count = 0;
					if (this.menuItemModifiers && this.menuItemModifiers[canvasIdx]) {
						Object.keys(this.menuItemModifiers[canvasIdx]).forEach((menuItemIdx) => {
							count = count + this.menuItemModifiers[canvasIdx][menuItemIdx].length;
						});
					}
					if (count < modCanvas.min) {
						this.menuItemSelected.valid = false;
					}

					modCanvas.menuItems?.forEach((modifier, menuItemIdx) => {
						if (!modifier.ooMenuItem) {
							modifier.ooMenuItem = this.ooMenuItems.find((i) => i.menuItemKey === modifier.menuItemKey);
						}
						if (modifier.ooMenuItem?.canvases) {
							modifier.ooMenuItem.canvases.forEach((subModCanvas, modCanvasIdx) => {
								if (subModCanvas.online && subModCanvas.min > 0) {
									if (
										this.menuItemModifiers &&
										this.menuItemModifiers[canvasIdx][menuItemIdx] &&
										this.menuItemModifiers[canvasIdx][menuItemIdx].length > 0
									) {
										let count2 = this.menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx].length;

										if (count2 < subModCanvas.min) {
											this.menuItemSelected.valid = false;
										}
									}
								}
							});
						}
					});
				}
			});
		}
	}

	async validateOrder(order: Order) {
		this.dev('Validating order');
		this.saving = true;
		this.validCheck = await this.focuslink.validateOrder(this.venueKey, order);

		if (this.validCheck.outOfStock) {
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Sorry, the indicated items are currently out of stock. Please remove and select different items.',
				key: 'sidebar',
			});
			this.validCheck.outOfStock.forEach((x) => {
				const items = this.check.items.filter((i) => i.key === x);
				items.forEach((i) => {
					i.outOfStock = true;
					if (i.modifiers) {
						const modifiers = i.modifiers.filter((m) => m.key === x);
						modifiers.forEach((m) => {
							m.outOfStock = true;
						});
					}
				});
			});
			this.checkoutStep = 'check';
			this.validCheck = null;
			this.saving = false;
			throw new Error('out-of-stock');
		}

		this.check.verified = true;
		this.check.tax = this.validCheck.taxTotal;
		this.check.total = this.validCheck.checkTotal + this.check.tip;
		this.check.total = +(Math.round(this.check.total * 100) / 100).toFixed(2);
		this.check.orderTypeFee = this.validCheck.orderTypeFee;
		this.check.creditCardPassAlongFee = this.validCheck.creditCardPassAlongFee;
		this.saving = false;
		return;
	}

	async waitForOrderUpdate(venueKey: number, orderKey: string, i: number = 1) {
		let error: number = 0;
		let orderStatus;
		while (i < 60) {
			if (this.orderStatusEmitterListener === 'success') {
				orderStatus = await this.focuslink.getOrder(venueKey, orderKey);
				this.check.status = orderStatus.status;
				this.check.checkNumber = orderStatus.checkNumber;
				this.check.checkKey = orderStatus.checkKey;
			} else if (this.orderStatusEmitterListener === 'error') {
				try {
					orderStatus = await this.focuslink.getOrder(venueKey, orderKey);
					this.check.status = orderStatus.status;
					this.check.checkNumber = orderStatus.checkNumber;
					this.check.checkKey = orderStatus.checkKey;
				} catch (error) {
					error++;
					if (error > 2) {
						throw new Error('Error getting order status update');
					}
				}

				if (orderStatus && orderStatus.status === 1) {
					return orderStatus;
				}

				if (orderStatus && orderStatus.status === 2) {
					this.checkoutStep = 'orderError';
					const errorMessage = this.parseOrderError(orderStatus.error);
					throw new Error(errorMessage);
				}
			} else {
				try {
					orderStatus = await this.focuslink.getOrder(venueKey, orderKey);
					this.check.status = orderStatus.status;
					this.check.checkNumber = orderStatus.checkNumber;
					this.check.checkKey = orderStatus.checkKey;
				} catch (error) {
					error++;
					if (error > 2) {
						throw new Error('Error getting order status update');
					}
				}

				if (orderStatus && orderStatus.status === 1) {
					return orderStatus;
				}

				if (orderStatus && orderStatus.status === 2) {
					this.checkoutStep = 'orderError';
					const errorMessage = this.parseOrderError(orderStatus.error);
					throw new Error(errorMessage);
				}
				i++;
			}

			await this.delay(500);
		}
		this.check.status = 2;
		throw new Error('Timeout waiting for order status update');
	}

	checkItemDtoToCheckItem(checkItemDto: CheckItemDto) {
		const checkItem = new OOCheckItem();
		checkItem.locked = true;
		checkItem.key = checkItemDto.menuItemKey;
		checkItem.name = checkItemDto.name;
		checkItem.qty = checkItemDto.quantity;
		checkItem.price = checkItemDto.price;
		checkItem.priceNumber = checkItemDto.priceNumber;
		checkItem.priceNumberName = checkItemDto.priceNumberName;
		checkItem.taxable = checkItemDto.taxable;
		checkItem.uuid = checkItemDto.uuid;

		checkItem.modifiers = [];
		checkItemDto.modifiers &&
			checkItemDto.modifiers.forEach((modifer) => {
				checkItem.modifiers.push({
					key: modifer.menuItemKey,
					name: modifer.name,
					price: modifer.price,
					priceNumber: modifer.priceNumber,
					priceNumberName: modifer.priceNumberName,
					taxable: modifer.taxable,
					level: 1,
				});
				modifer.modifiers &&
					modifer.modifiers.forEach((submodifer) => {
						checkItem.modifiers.push({
							key: submodifer.menuItemKey,
							name: submodifer.name,
							price: submodifer.price,
							priceNumber: submodifer.priceNumber,
							priceNumberName: submodifer.priceNumberName,
							taxable: submodifer.taxable,
							level: 2,
						});
					});
			});

		return checkItem;
	}

	getCustomerCard(token: string) {
		return this.customer.creditCards.find((c) => c.token === token);
	}

	parsePhoneNumber(phone: string) {
		phone = phone.replace(/\D/g, '');
		if (phone && phone.length > 10) {
			const start = phone.length - 10;
			phone = phone.substring(start);
		}
		return phone;
	}

	getCurrentMenuItemTotal(menuItem: OOMenuItem, qty: number) {
		return this.getCheckItemTotal(this.menuItemToCheckItem(menuItem, qty));
	}

	updateMenuItemTotal() {
		this.menuItemTotal = this.getCurrentMenuItemTotal(this.menuItemSelected, this.menuItemQty);
	}

	openPromo(templateRef) {
		this.modalRef = this.app.modal.open(templateRef, {
			centered: true,
			scrollable: false,
			// size: 'lg'
		});
	}

	billingToShipping() {
		this.check.shipping.firstName = this.check.billing.firstName;
		this.check.shipping.lastName = this.check.billing.lastName;
		this.check.shipping.phone = this.check.billing.phone && this.parsePhoneNumber(this.check.billing.phone);
		this.check.shipping.email = this.check.billing.email;
		this.check.shipping.address1 = this.check.billing.address1;
		this.check.shipping.address2 = this.check.billing.address2;
		this.check.shipping.city = this.check.billing.city;
		this.check.shipping.state = this.check.billing.state;
		this.check.shipping.postalCode = this.check.billing.postalCode;
		this.check.shipping.country = this.check.billing.country;
	}

	async processOrder(order: Order) {
		this.trackOrderStatus(order.checkKey);
		this.checkoutStep = 'orderSubmitting';

		this.dev('Check');
		this.dev(this.check);
		this.dev('Order');
		this.dev(this.order);
		LogRocket.identify(this.venueKey.toString(), {
			name: `${order.firstName} ${order.lastName}`,
			checkKey: this.check.checkKey,
		});

		let sendToProcessor = true;

		if (this.paymentMode === 'store') {
			sendToProcessor = false;
		}

		if (this.venueKey === 6383 && this.paymentMode !== 'applepay') {
			this.check.creditCard.cardNumber = 4321000000001119;
			this.check.creditCard.cardCvv = 333;
			this.check.creditCard.cardExpirationMonth = '12';
			this.check.creditCard.cardExpirationYear = new Date().getFullYear().toString();
		}

		const totalNoTip = +(Math.round((this.check.total - this.check.tip) * 100) / 100).toFixed(2);

		//Order Name handling
		if (this.orderType && this.orderType.includeGuestNameOnOrder) {
			let orderPrintName;
			this.check.billing.firstName;
			this.check.billing.lastName;
			switch (this.orderType.includeNameFormat) {
				case OrderTypeIncludeNameFormat.FIRSTANDLAST:
					orderPrintName = `${this.check.billing.firstName} ${this.check.billing.lastName}`;
					break;
				case OrderTypeIncludeNameFormat.FIRSTANDLASTINITIAL:
					orderPrintName = `${this.check.billing.firstName} ${this.check.billing.lastName.substr(0, 1)}`;
					break;
				case OrderTypeIncludeNameFormat.FIRSTNAME:
					orderPrintName = this.check.billing.firstName;
					break;
				case OrderTypeIncludeNameFormat.LASTANDFIRST:
					orderPrintName = `${this.check.billing.lastName} ${this.check.billing.firstName}`;
					break;
				case OrderTypeIncludeNameFormat.LASTNAME:
					orderPrintName = this.check.billing.lastName;
					break;
				default:
					orderPrintName = `${this.check.billing.firstName} ${this.check.billing.lastName}`;
					break;
			}
			if (this.orderType.includeNamePrefix) {
				switch (this.orderType.includeNamePrefix) {
					case OrderTypeIncludeNamePrefix.NONE:
						break;
					case OrderTypeIncludeNamePrefix.FOR:
						orderPrintName = `For: ${orderPrintName}`;
						break;
					case OrderTypeIncludeNamePrefix.NAME:
						orderPrintName = `Name: ${orderPrintName}`;
						break;
					case OrderTypeIncludeNamePrefix.GUEST:
						orderPrintName = `Guest: ${orderPrintName}`;
						break;
					case OrderTypeIncludeNamePrefix.ORDER:
						orderPrintName = `Order: ${orderPrintName}`;
						break;
					default:
						break;
				}
			}
			this.order.seats[0].items.push(
				new OrderItem({
					menuItemKey: this.ooMenuConfig.exceptionMenuId,
					price: 0.0,
					quantity: 1,
					priceNumber: 1,
					name: orderPrintName,
					kitchenComment: true,
				})
			);
		}

		order.total = totalNoTip;
		(order.taxtotal = this.check.tax), (order.remainingBalance = 0);
		(order.orderTypeChargeTotal = this.check.orderTypeFee),
			(order.creditCardPassAlongFee = this.check.creditCardPassAlongFee),
			(order.seats[0].total = totalNoTip);
		order.seats[0].taxtotal = this.check.tax;
		order.seats[0].orderTypeChargeTotal = this.check.orderTypeFee;
		order.seats[0].creditCardPassAlongFee = this.check.creditCardPassAlongFee;
		order.seats[0].remainingBalance = 0;
		order.firstName = this.check.billing.firstName;
		order.lastName = this.check.billing.lastName;
		order.address = this.check.shipping.address1;
		order.address2 = this.check.shipping.address2;
		order.city = this.check.shipping.city;
		order.state = this.check.shipping.state;
		order.zip = this.check.shipping.postalCode;
		order.email = this.check.billing.email;
		order.phone = this.check.billing.phone && this.parsePhoneNumber(this.check.billing.phone);
		order.table = this.check.billing.lastName;
		order.leadTime = order.futureOrder ? this.check.leadTime : undefined;
		order.onlineCustomer = this.onlineCustomer || undefined;

		this.check.loyaltyPhone = this.check.billing.phone;

		this.paymentToken = this.customerCardToken || this.paymentToken;
		this.orderSocketService.putOrderStatusChange('orderAssembling');
		if (this.orderPayment) {
			if (this.orderPayment.postalCode) order.zip = this.orderPayment.postalCode;
			try {
				this.dev(`Payment auth`);
				//this.saving = true;
				this.orderPayment.checkKey = this.order.checkKey;

				if (this.kioskMode) {
					if (this.orderPayment.sendToProcessor) {
						this.paymentAuthorization = await this.paymentAuth(this.orderPayment);
					} else {
						// console.log(this.orderPayment);
						// console.log(this.paymentAuthorization);
					}
				} else {
					this.paymentAuthorization = await this.paymentAuth(this.orderPayment);
				}

				this.orderSocketService.putOrderStatusChange('orderPaymentAuth');
				this.saving = false;
			} catch (error) {
				console.log(error);
				this.saving = false;
				this.app.loading(false);
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: 'Problem processing payment', detail: `${error.error.error}` });
				this.checkoutStep = 'paymentMethod';

				return;
			}
		} else {
			this.orderSocketService.putOrderStatusChange('noPaymentRequired');
		}

		if (this.orderType.useLinkKeyTable) {
			order.table = this.query.table;
		}

		if (this.orderType.atTable) {
			sendToProcessor = false;
			order.sendReceipt = false;
			const link = this.venue.ooLinks.find((l) => l.key === this.query.linkKey);
			order.linkKey = this.query.linkKey;
			order.table = link.id;
			if (this.paymentToken) {
				order.seats[0].tabToken = this.paymentToken;
				order.seats[0].tabAuthorization = JSON.stringify(this.paymentAuthorization);
				order.seats[0].tabTipPercent = this.check.tipPercent;
				const payment = new OrderPayment({
					amount: this.check.total,
					tip: this.check.tip,
					token: this.paymentToken,
					type: OrderPaymentTypes.CreditCard,
					firstName: order.firstName,
					lastName: order.lastName,
					address1: order.address,
					city: order.city,
					state: order.state,
					postalCode: order.zip,
					focusPay: this.venue.ccProcessor === CCProcessors.FOCUSPAYADYEN ? true : false,
					paymentKey: this.orderPayment.paymentKey || undefined,
					kioskPaymentRequestKey: this.orderPayment.kioskPaymentRequestKey,
				});
			}
		}

		let outstandingCheckTip: number = this.check.tip;
		order.seats[0].payments = [];
		if (this.giftAccount && this.giftAmount) {
			let giftCardTip: number = 0;
			if (this.giftBalanceAmount >= this.giftAmount + outstandingCheckTip) {
				giftCardTip = outstandingCheckTip;
				outstandingCheckTip = outstandingCheckTip - giftCardTip;
			} else {
				giftCardTip = this.giftBalanceAmount - this.giftAmount;
				outstandingCheckTip = outstandingCheckTip - giftCardTip;
			}
			const payment = new OrderPayment({
				amount: this.giftAmount,
				tip: giftCardTip,
				type: OrderPaymentTypes.GiftCard,
				token: this.giftAccount,
			});
			order.seats[0].payments.push(payment);
			order.seats[0].total = order.seats[0].total + this.giftAmount;
			order.total = order.seats[0].total;
		}
		if (sendToProcessor && this.check.total > 0) {
			const payment = new OrderPayment({
				amount: this.check.total,
				tip: outstandingCheckTip,
				token: this.paymentToken,
				authorization: JSON.stringify(this.paymentAuthorization),
				type: OrderPaymentTypes.CreditCard,
				firstName: order.firstName,
				lastName: order.lastName,
				address1: order.address,
				city: order.city,
				state: order.state,
				postalCode: order.zip,
				pspReference: this.paymentAuthorization.RefNo,
				invoiceNumber: this.paymentAuthorization.InvoiceNo,
				venueKey: this.venue.venueKey,
				displayName: this.paymentAuthorization.Account,
				displayNumber: this.paymentAuthorization.Account,
				authCode: this.paymentAuthorization.AuthCode,
				kioskPaymentRequestKey: this.orderPayment.kioskPaymentRequestKey,
			});
			order.seats[0].payments.push(payment);
		}

		if (this.paymentMode === 'store') {
			order.remainingBalance = order.total;
			order.seats[0].remainingBalance = order.seats[0].total;
			order.seats[0].items.push(
				new OrderItem({
					menuItemKey: this.linkedMenuConfig ? this.linkedMenuConfig.commentsMenuId : this.ooMenuConfig.commentsMenuId,
					price: 0,
					quantity: 1,
					name: 'NOT PAID',
					kitchenComment: true,
				})
			);
		}

		this.orderSocketService.putOrderStatusChange('orderSubmitted');
		//this.saving = true;
		let orderRes: any;
		try {
			this.dev('Sending order');
			if (this.query.test) {
				console.log(this.order);
				this.saving = false;
				this.app.msgSvc.add({ severity: 'info', detail: 'Order generated to console.' });
				return;
			}
			this.googleAnalytics.eventEmitter('order_submit', 'order', 'submit', order.checkKey);
			this.app.initProduct(this.venueKey, FocusLinkProduct.OnlineOrder, ProductUseFunction.TRANSACTIONCOMPLETE, order.checkKey);

			orderRes = await this.focuslink.sendOrder(this.venueKey, order);
			try {
				this.venueService.subscriptionOOmenuItems.unsubscribe();
			} catch (e) {
				console.log('Unsubscribe error');
			}

			this.saving = false;
		} catch (error) {
			console.error(error);
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Error saving order',
				key: 'sidebar',
			});
			this.googleAnalytics.eventEmitter('order_submit_error', 'order', 'submit', order.checkKey);
			this.saving = false;
			return;
		}

		if (this.venue.ccProcessor === CCProcessors.SHIFT4 && this.paymentToken) {
			this.focuslink.customerInvoicePost(this.venueKey, this.order.checkKey, this.paymentInvoiceNumber, 'onlineorder', this.paymentToken, false);
		}

		this.googleAnalytics.purchaseEmitter(this.googleAnalytics.orderToGtagPurchase(order));

		if (this.customer) {
			this.customer = await this.focuslink.getCustomer(this.customer.key);
		}

		if (order.futureOrder) {
			this.app.msgSvc.clear();
			this.continueMessage = 'Start New Order';
			this.checkoutStep = 'orderComplete';
			this.orderStatusMessage = 'Order Complete!';
			this.allowSubmit = true;
			this.check.status = 1;
		} else {
			this.orderStatusMessage = 'Sending Order';
			this.allowSubmit = false;
			try {
				//this.saving = true;
				await this.waitForOrderUpdate(this.venueKey, orderRes.orderKey);
				this.saving = false;
				this.orderStatusMessage = 'Order Complete!';
				this.allowSubmit = true;

				let token = btoa(`${this.check.checkKey}#0`);
				this.receiptUrl = `https://pay.focuspos.com/${token}`;

				if (this.orderType.atTable) {
					this.app.msgSvc.add({
						severity: 'success',
						detail: 'Order submitted!',
					});
					this.sbCart.close();
					this.storage.set(`${this.venueKey}-${this.query.table}`, this.check.checkKey);
					console.log(`Storing check for @table transactions - ${this.check.checkKey}`);
					await this.reset(true);
				} else {
					console.log(`before app.megSvc clear`);

					this.app.msgSvc.clear();

					this.checkoutStep = 'orderComplete';
				}

				return;
			} catch (error) {
				console.error(error);
				this.saving = false;
				this.orderStatusMessage = 'Order Error!';
				this.allowSubmit = true;
				this.app.msgSvc.add({
					severity: 'error',
					detail: error,
					key: 'sidebar',
				});
				return;
			}
		}
	}

	returnFromOrderTypeTimeSelect() {
		if (this.futureOrderTime && this.futureOrderDate) {
			this.check.futureOrder = 'later';
		}
		this.timeRangeActive = this.activeTimeRanges();
		this.buildMenu();
	}

	selectTip(id: number) {
		switch (id) {
			case 0: {
				this.check.tip = 0;
				this.check.tipPercent = 0;
				break;
			}
			case 1: {
				if (!this.orderType.atTable) {
					this.check.tip = +this.calcTip(this.check.subtotal, this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip1);
				}
				if (this.orderType.atTable) {
					this.check.tipPercent = this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip1 * 100;
				}
				break;
			}
			case 2: {
				if (!this.orderType.atTable) {
					this.check.tip = +this.calcTip(this.check.subtotal, this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip2);
				}
				if (this.orderType.atTable) {
					this.check.tipPercent = this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip2 * 100;
				}
				break;
			}
			case 3: {
				if (!this.orderType.atTable) {
					this.check.tip = +this.calcTip(this.check.subtotal, this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip3);
				}
				if (this.orderType.atTable) {
					this.check.tipPercent = this.venue.ooOrderTypes.find((ot) => ot.key === this.check.orderType).tip3 * 100;
				}
				break;
			}
			case 4: {
				if (!this.orderType.atTable) {
					this.check.tip = this.tipCustom;
				}
				break;
			}
		}
		this.updateCheckTotals(this.check);
	}

	async trackOrderStatus(checkKey: string) {
		this.orderSocketService.connect(this.venueKey, checkKey);
		this.orderSocketService.socket.subscribe(
			(msg) => {
				if (msg.subject === OrderSocketMessage.CHECK) {
					this.orderSocketService.putOrderStatusChange(msg.status);
				}
				if (msg.subject === OrderSocketMessage.CUSTOMER) {
					if (msg.status === 'customerKey') {
						this.storage.set('fcck', msg.customerKey);
					}
				}
			},
			(err) => {
				console.log(err);
			}
			// () => {
			// 	this.orderSocketService.socket.unsubscribe();
			// 	this.orderSocketService.connect(this.venueKey, checkKey);
			// }
		);
	}

	getCanvas(key: number): OOCanvas {
		const canvas = this.ooCanvases.find((c) => c.canvasKey === key);
		return canvas;
	}

	alternateReset() {
		if (this.checkoutStep === 'orderComplete') {
			this.reset(true);
		} else {
			this.checkoutStep = 'check';
			this.validCheck = null;
			this.allowSubmit = true;
			this.continueMessage = 'Checkout';
			if (this.orderType.atTable) {
				this.continueMessage = 'Submit Order';
			}
			if (this.savedCheck) {
				this.continueMessage = 'Order New Items';
			}
			this.checkoutStepNum = 0;
			this.orderStatusMessage = null;
			this.paymentResult = null;
			this.giftAccount = null;
			this.giftAmount = null;
		}
	}

	async reset(initCheck?: boolean) {
		console.log(`Resetting online order experience`);
		this.dev('reset');
		this.validCheck = null;
		if (this.checkoutStep === 'orderComplete' || this.checkoutStep === 'paymentComplete') {
			initCheck = true;
		}
		if (initCheck) {
			await this.initCheck();
		}

		this.orderType = null;
		this.orderTypeOptions = null;
		this.check.orderType = null;

		if (this.query.orderType) {
			this.orderType = this.venue.ooOrderTypes.find((ot) => ot.key === +this.query.orderType);
			this.check.orderType = this.orderType.key;
		}

		if (!this.orderType) {
			await this.availableOrderTypes();
		}

		this.continueMessage = 'Checkout';
		if (this.orderType.atTable) {
			this.continueMessage = 'Submit Order';
		}
		if (this.savedCheck) {
			this.continueMessage = 'Order New Items';
		}
		this.checkoutStep = 'check';
		this.checkoutStepNum = 0;
		this.customerCardToken = null;
		// this.paymentToken = null;
		this.paymentAuthorization = null;
		this.paymentMode = null;
		this.tipCustom = null;
		this.tipSelected = null;
		this.check.tip = 0;
		this.receiptUrl = null;
		this.allowSubmit = true;
		this.check.creditCard.displayName = null;
		this.order = null;
		this.orderStatusMessage = null;
		this.paymentResult = null;
		this.giftAccount = null;
		this.giftAmount = null;
		if (!this.futureOrderDate && !this.futureOrderTime) {
			this.futureOrderDate = new Date();
			this.futureOrderTime = null;
		}

		this.app.msgSvc.clear('sidebar');
	}

	async availableOrderTypes() {
		if (this.venue.ooOrderTypes && this.venue.ooOrderTypes.length > 0) {
			this.orderType = this.venue.ooOrderTypes[0];
			const availableOrderTypes = this.venue.ooOrderTypes.filter((i) => i.active && !i.atTable && !i.useLinkKeyTable);
			if (availableOrderTypes.length > 0) {
				this.orderTypeOptions = availableOrderTypes.map((ot) => ({
					label: ot.displayName,
					value: ot.key,
				}));
				this.check = new OOCheck();
				this.check.orderType = availableOrderTypes[0].key;
			}
		}
		this.orderType.inactive = this.acceptingOrders(this.venue) ? false : true;
		if (this.orderType.inactive) {
			await this.venueService.buildFutureOrderTimeSlots();
		}
	}

	calcTip(subtotal: number, tip: number) {
		const value = subtotal * tip;
		return (Math.round(value * 100) / 100).toFixed(2);
	}

	getMenuItem(key: number): OOMenuItem {
		const menuItem = this.ooMenuItems.find((mi) => mi.menuItemKey === key);
		return menuItem;
	}

	addMenuItem(menuItem: OOMenuItem, qty: number, checkItemIdx?: number, quickAdd: boolean = false, existingItemUUID?: string) {
		if (this.check.items.length === 0) {
			this.app.initProduct(this.venueKey, FocusLinkProduct.OnlineOrder, ProductUseFunction.CARTITEM);
		}
		const checkItem = this.menuItemToCheckItem(menuItem, qty, undefined, undefined, existingItemUUID);

		if (this.menuItemComment1) {
			const commentItem = new OOCheckItem({
				key: this.linkedMenuConfig ? this.linkedMenuConfig.commentsMenuId : this.ooMenuConfig.commentsMenuId,
				name: this.menuItemComment1,
				price: 0,
				kitchenComment: true,
			});
			checkItem.modifiers.push(commentItem);
		}
		if (this.menuItemComment2) {
			const commentItem = new OOCheckItem({
				key: this.linkedMenuConfig ? this.linkedMenuConfig.exceptionMenuId : this.ooMenuConfig.exceptionMenuId,
				name: `For ${this.menuItemComment2}`,
				price: 0,
				kitchenComment: true,
			});
			checkItem.modifiers.push(commentItem);
		}
		if (checkItemIdx >= 0) {
			this.check.items[checkItemIdx] = checkItem;
		} else {
			this.check.items.push(checkItem);
		}
		this.updateCheckTotals(this.check);
		if (!quickAdd) {
			this.modalRef.close();
		}

		// this.sbCart.open();
		this.app.msgSvc.add({
			severity: 'success',
			summary: `Added ${menuItem.displayName || menuItem.name} to your cart.`,
			life: 1000,
		});

		this.onlineOrderService.storeOrder(this.generateOrder(this.check, false), this.useKey);
		this.dev(this.check);
	}

	getMenuItemPrice(item: OOMenuItem, applicablePriceNumber?: number, log?: boolean) {
		let price = 0;
		const priceNumber = applicablePriceNumber || item.priceNumber;
		if (item) {
			price = item.price;
			switch (priceNumber) {
				case 1: {
					price = item.price;
					break;
				}
				case 2: {
					price = item.price2;
					break;
				}
				case 3: {
					price = item.price3;
					break;
				}
				case 4: {
					price = item.price4;
					break;
				}
				case 5: {
					price = item.price5;
					break;
				}
				case 6: {
					price = item.price6;
					break;
				}
				case 7: {
					price = item.priceSub;
					break;
				}
				case 8: {
					price = item.priceExtra;
					break;
				}
				case 9: {
					price = item.priceNo;
					break;
				}
				case 10: {
					price = item.priceMod;
					break;
				}
			}
		}
		return +price;
	}

	openTos(templateRef) {
		this.modalRef = this.app.modal.open(templateRef, {
			centered: true,
			scrollable: true,
		});
	}

	selectFutureOrderDate(date) {
		const m = moment(date);
		this.futureOrderTimeOptions = this.venueService.futureOrderTimeSlots[m.day()];
		if (m.isSame(moment(), 'days')) {
			this.futureOrderTimeOptions = this.futureOrderTimeOptions.filter((o) => {
				const mIdx = moment(date).hour(o.value.split(':')[0]).minute(o.value.split(':')[1]).second(0);
				if (mIdx.isSameOrAfter(moment(), 'minutes')) {
					let orderLeadTime = this.venue.orderLeadTime;
					if (this.orderType && this.orderType.orderLeadTime) {
						orderLeadTime += this.orderType.orderLeadTime;
					}
					if (mIdx.isBefore(moment().add(orderLeadTime, 'minutes'))) {
						return false;
					}
					return true;
				}
			});
		}
		if (this.futureOrderTimeOptions.length === 0) {
			this.futureOrderTimeOptions = [
				{
					label: 'No Times Available',
					disabled: true,
				},
			];
		}
		this.futureOrderTime = this.futureOrderTime ? this.futureOrderTime : null;
	}

	buildMenu() {
		this.ooMenuItems.forEach((mi) => {
			mi.canvases = mi.canvases.filter((i) => i.online);

			mi.canvases.forEach((modifierCanvas, canvasIndex) => {
				const online = modifierCanvas.online;
				const sortOrder = modifierCanvas.sortOrder;
				if (modifierCanvas.min === undefined) {
					modifierCanvas.min = 0;
				}

				const canvas = this.getCanvas(modifierCanvas.canvasKey);

				Object.assign(modifierCanvas, canvas);

				modifierCanvas.online = online;
				modifierCanvas.sortOrder = sortOrder;
				if (!modifierCanvas.menuItems?.some((modItem) => modItem.online)) {
					modifierCanvas.online = false;
				}
			});

			mi.canvases = mi.canvases.filter((i) => i.online);

			mi.imageUrl = mi.imageKey
				? `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venue.linkedVenueKey || this.venueKey}/${mi.imageKey}`
				: null;

			this.venueService.sortForDisplay(mi.canvases);

			if (mi.OOMenuItemTags) {
				mi.OOMenuItemTags.forEach((itemTag) => {
					if (!this.menuItemTagList.some((tag) => tag.key === itemTag.tagKey) && itemTag.OOTags) {
						this.menuItemTagList.push(itemTag.OOTags);
					}
				});
			}
		});

		this.ooCanvases.forEach((c) => {
			let imageKeysFound: boolean = false;
			c.menuItems.forEach((mi, miIndex) => {
				mi.ooMenuItem = this.ooMenuItems.find((i) => i.menuItemKey === mi.menuItemKey);

				if (!mi.ooMenuItem) {
					mi.online = false;
				} else {
					mi.ooMenuItem.name = mi.ooMenuItem.name.toString();
					if (mi.ooMenuItem?.imageKey) {
						imageKeysFound = true;
					}
					mi.hideImages = c.hideImages;
				}
			});

			if (!imageKeysFound) {
				c.menuItems.forEach((mi) => (mi.hideImages = true));
			}

			const canvasActiveStatus = this.canvasTimeRangeStatus(c);

			c.menuItems = c.menuItems.filter((mi) => mi.online);
			c.displayName = c.displayName || c.name;
			c.imageKey = c.imageKey;
			c.available = canvasActiveStatus.available;
			c.unavailableMessage = c.available ? undefined : canvasActiveStatus.message;

			this.venueService.sortForDisplay(c.menuItems);

			c.menuItems.forEach((mi) => {
				const menuItemActiveStatus = this.canvasItemTimeRangeStatus(mi);
				if (c.sharedFrom) {
					if (mi['sharedFromImageUrl']) {
						mi.ooMenuItem.imageUrl = mi['sharedFromImageUrl'];
						const item = this.ooMenuItems.find((i) => i.menuItemKey === mi.menuItemKey);
						item && (item.imageUrl = mi['sharedFromImageUrl']);
					}
				}

				if (mi.ooMenuItem) {
					mi.ooMenuItem.available = c.available ? menuItemActiveStatus.available : c.available;
					mi.ooMenuItem.unavailableMessage = c.available
						? mi.ooMenuItem.available
							? undefined
							: menuItemActiveStatus.message
						: c.unavailableMessage;
				}
				const menuItem = this.getMenuItem(mi.menuItemKey);

				Object.assign(mi, menuItem);
				if (c.online && mi.online && !this.canvasMenuItems.some((itm) => itm.menuItemKey === mi.menuItemKey) && mi.ooMenuItem) {
					if (this.query.menuKey) {
						if (c.menuIds.includes(this.query.menuKey)) {
							this.canvasMenuItems.push(mi);
						}
					} else {
						this.canvasMenuItems.push(mi);
					}
				}
				if (mi.ooMenuItem?.OOMenuItemTags && mi.ooMenuItem?.OOMenuItemTags.length > 0) {
					if (!this.canvasMenuItemsWithTags.some((itm) => itm.menuItemKey === mi.menuItemKey || itm.displayName === mi.displayName)) {
						this.canvasMenuItemsWithTags.push(mi);
					}
				}
			});
		});

		this.ooCanvasesOnline = this.ooCanvases.filter((c) => c.online && c.menuItems?.length > 0);

		if (!this.venue.displayUnavailableTimedCanvas) {
			this.ooCanvasesOnline = this.ooCanvasesOnline.filter((c) => c.available);
		}

		let activeMenu = this.venue.ooMenus.find((m) => m.active);
		if (this.query.menuKey) {
			activeMenu = this.venue.ooMenus.find((m) => m.key === this.query.menuKey) || activeMenu;
		}
		const activeCanvases = [];

		this.ooCanvasesOnline.forEach((c, idx) => {
			if (activeMenu && !c.menuIds) {
			} else if (activeMenu && c.menuIds && !c.menuIds.includes(activeMenu.key)) {
			} else if (!activeMenu && c.menuIds && !c.menuIds.includes('0')) {
			} else {
				activeCanvases.push(c);
			}
		});
		activeMenu?.externalLinks?.forEach((link) => {
			activeCanvases.push(
				new OOCanvas({
					name: link.label,
					displayName: link.label,
					externalUrl: link.url,
				})
			);
		});
		this.ooCanvasesOnline = activeCanvases;
		this.venueService.sortForDisplay(this.ooCanvasesOnline);

		this.selectedCanvas = this.ooCanvasesOnline[0];
	}

	buildCanvasOptions(canvases: OOCanvas[], parentCanvasIdx?: number, parentMenuItemIdx?: number, level = 0) {
		if (level === 0) {
			this.menuItemModifiers = {};
			this.menuItemSubModifiers = {};
		}
		canvases = canvases.filter((i) => i.online);
		if (canvases && canvases.length > 0) {
			if (canvases.length > 1) {
				this.venueService.sortForDisplay(canvases);
			}
			canvases.forEach((canvas, canvasIdx) => {
				if (level === 0) {
					this.menuItemModifiers[canvasIdx] = {};
					this.menuItemSubModifiers[canvasIdx] = {};
				}
				if (level > 0) {
					this.menuItemSubModifiers[parentCanvasIdx][parentMenuItemIdx][canvasIdx] = [];
				}
				this.venueService.sortForDisplay(canvas.menuItems);

				canvas.options = canvas.menuItems
					.filter((mi) => mi.online && mi.ooMenuItem)
					.map((mi, menuItemIdx) => {
						if (level === 0) {
							this.menuItemModifiers[canvasIdx][menuItemIdx] = [];
							this.menuItemSubModifiers[canvasIdx][menuItemIdx] = {};
						}
						let label;

						if (mi.priceNumber && this.getMenuItemPrice(mi.ooMenuItem, mi.priceNumber) > 0) {
							label = (mi.displayName || mi.ooMenuItem.name) + ' $' + this.getMenuItemPrice(mi.ooMenuItem, mi.priceNumber).toFixed(2);
						} else {
							label = mi.displayName || mi.ooMenuItem.name;
						}

						if (mi.ooMenuItem.canvases && level === 0) {
							this.buildCanvasOptions(mi.ooMenuItem.canvases, canvasIdx, menuItemIdx, level + 1);
						}

						let modCanvasIdx;
						let modMenuItemIdx;
						if (level > 0) {
							modCanvasIdx = canvasIdx;
							modMenuItemIdx = menuItemIdx;
							canvasIdx = parentCanvasIdx;
							menuItemIdx = parentMenuItemIdx;
						}

						return {
							label: label,
							value: {
								preselected: mi.preselected,
								canvasIdx: canvasIdx,
								menuItemIdx: menuItemIdx,
								modCanvasIdx: modCanvasIdx,
								modMenuItemIdx: modMenuItemIdx,
								menuItem: mi,
							},
						};
					});

				// canvas.options.some((cmi) => cmi.value?.preselected) && this.buildCanvasOptionsPreselect(canvas, canvasIdx, parentMenuItemIdx);
			});
		}
	}

	buildCanvasOptionsPreselect(canvas: OOCanvas, canvasIdx: number, parentMenuItemIdx: number) {
		const canvasDisplayIndex = this.menuItemSelected.canvases.findIndex((i) => i.canvasKey === canvas.canvasKey);

		canvas.options?.forEach((option, idx) => {
			if (option.value?.preselected) {
				this.menuItemModifiers[canvasIdx][parentMenuItemIdx].push(option.value);
				this.selectModifier(canvasDisplayIndex, idx, canvas, canvas.options[idx], { length: 0 });
			}
		});
	}

	activeTimeRanges() {
		const currentTime = moment(this.orderDueDateTime);

		const activeTimeRange = this.timeRangeList.filter((tr) => {
			const todaysTimeRangeTimes = tr.OOTimeRangeTimes.filter((trt) => trt.day === currentTime.day());

			return todaysTimeRangeTimes.some((trt) => {
				if (tr.startDate && tr.endDate && !currentTime.isBetween(moment(tr.startDate), moment(tr.endDate))) {
					return false;
				}

				const startTime1 = moment(trt.startTime, 'HH:mm').date(currentTime.date()).month(currentTime.month()).year(currentTime.year());
				let endTime1 = moment(trt.endTime, 'HH:mm').date(currentTime.date()).month(currentTime.month()).year(currentTime.year());
				const startTime2 = moment(trt.startTime2, 'HH:mm').date(currentTime.date()).month(currentTime.month()).year(currentTime.year());
				let endTime2 = moment(trt.endTime2, 'HH:mm').date(currentTime.date()).month(currentTime.month()).year(currentTime.year());

				if (endTime1.isBefore(startTime1)) {
					endTime1 = endTime1.add(1, 'days');
				}

				if (endTime2.isBefore(startTime2)) {
					endTime2 = endTime2.add(1, 'days');
				}

				const active1 = currentTime.isBetween(startTime1, endTime1);
				const active2 = currentTime.isBetween(startTime2, endTime2);
				if (active1 || active2) {
					return true;
				}
				return false;
			});
		});
		return activeTimeRange;
	}

	canvasTimeRangeStatus(canvas: OOCanvas) {
		const canvasStatus = {
			available: true,
			message: undefined,
		};
		if (canvas.OOCanvasTimeRange?.length > 0) {
			for (let ctr of canvas.OOCanvasTimeRange) {
				const ctrActive = this.timeRangeActive.find((i) => i.key === ctr.timeRangeKey);
				if (ctrActive) {
					canvasStatus.available = true;
					break;
				} else {
					canvasStatus.available = false;
					const trActive = this.timeRangeList.find((i) => i.key === ctr.timeRangeKey);
					if (trActive && trActive.message) {
						canvasStatus.message = this.timeRangeList?.find((i) => i.key === ctr.timeRangeKey).message;
					} else {
						canvasStatus.message = 'Sorry, these menu items are currently unavailable.';
					}
				}
			}
		}
		return canvasStatus;
	}

	canvasItemTimeRangeStatus(canvasItem: OOCanvasMenuItem) {
		const canvasItemStatus = {
			available: true,
			message: undefined,
		};

		if (canvasItem.OOCanvasMenuItemTimeRange?.length > 0) {
			for (let citr of canvasItem.OOCanvasMenuItemTimeRange) {
				const citrActive = this.timeRangeActive.find((i) => i.key === citr.timeRangeKey);

				if (citrActive || !(citr.timeRangeKey && this.timeRangeList.some((i) => i.key === citr.timeRangeKey))) {
					canvasItemStatus.available = true;
					break;
				} else {
					canvasItemStatus.available = false;
					canvasItemStatus.message =
						this.timeRangeList.find((i) => i.key === citr.timeRangeKey).message || `Sorry, this item is currently unavailable.`;
					break;
				}
			}
		}
		return canvasItemStatus;
	}

	async filterMenuItems(input) {
		for (let item of this.ooMenuItems) {
			if (item.name.includes(input) || item.description.includes(input)) {
				this.filteredMenuItems.push(item);
			}
		}
	}

	async saveNewCustomer() {
		this.savingNewCustomer = true;
		try {
			this.customer = await this.focuslink.updateCustomerPassword(this.check.customerKey, btoa(this.password));
			this.savingNewCustomer = false;
			this.login(this.check.customerKey, this.passwordConfirm);
			this.nextStep();
		} catch (error) {
			this.savingNewCustomer = false;
			this.app.msgSvc.add({
				severity: 'error',
				detail: 'Error saving customer',
				key: 'sidebar',
			});
		}
	}

	setOnlineCustomerToCheckBilling() {
		this.dev(this.onlineCustomer);
		this.dev(`Setting online customer to billing`);
		this.check.billing.firstName = this.onlineCustomer.firstName;
		this.check.billing.lastName = this.onlineCustomer.lastName;
		this.check.billing.email = this.onlineCustomer.email;
		this.check.billing.phone = this.onlineCustomer.phone;

		if (this.onlineCustomer.creditCards?.length > 0) {
			this.paymentUseNewCard = false;
		}
		this.dev(this.check.billing);
	}

	storedCreditCardResponse(token: string) {
		if (token !== 'newCard') {
			const storedCreditCard = this.onlineCustomer.creditCards.find((i) => i.token === token);
			storedCreditCard.lastUsed = new Date();
			this.orderPayment = new OrderPayment({
				amount: this.check.total,
				tip: this.check.tip,
				token: token,
				type: OrderPaymentTypes.CreditCard,
				firstName: this.onlineCustomer.firstName,
				lastName: this.onlineCustomer.lastName,
				address1: this.check.billing.address1,
				city: this.check.billing.city,
				state: this.check.billing.state,
				postalCode: this.onlineCustomer.postalCode,
			});
			this.paymentToken = token;
			this.processOrder(this.order);
		} else {
			this.app.loading(true);
			this.paymentUseNewCard = true;
		}
	}

	async nextStep() {
		this.dev(this.checkoutStep);
		this.dev(this.check);

		if (this.checkoutStep === 'check') {
			this.dev(this.checkoutStep);
			this.dev(this.orderType);

			if (this.onlineCustomer && this.orderType.storeCustomerData) {
				this.setOnlineCustomerToCheckBilling();
			}

			if (
				this.orderTypeOptions ||
				(this.orderType && this.orderType.futureOrders) ||
				(this.orderType && this.orderType.ooOrderTypeFields && this.orderType.ooOrderTypeFields.length > 0)
			) {
				this.continueMessage = 'Continue';
				this.checkoutStep = 'orderHow';
				this.app.msgSvc.clear();
				this.allowSubmit = true;
				if (!this.check.orderType) {
					this.check.orderType = this.orderType.key;
				}
				this.selectOrderType(this.check.orderType);

				return;
			}
			if (this.orderType && this.orderType.ignoreOOEnabledTime) {
				if (!this.selectOrderType(this.check.orderType)) {
					return;
				}
			} else if (!this.acceptingOrders(this.venue) && this.orderType && !this.orderType.futureOrders) {
				this.allowSubmit = false;
				this.app.msgSvc.add({
					severity: 'error',
					detail: 'Currently Not Accepting Orders',
					key: 'sidebar',
				});
				this.continueMessage = 'Currently Not Accepting Orders';
				return;
			} else {
				if (!this.selectOrderType(this.check.orderType)) {
					return;
				}
			}
		}

		if (this.checkoutStepNum === 0) {
			const orderForValidation = this.generateOrder(this.check);
			this.order = this.generateOrder(this.check, true);
			try {
				await this.validateOrder(orderForValidation);
				this.checkoutStepNum = 1;
			} catch (error) {
				this.saving = false;
				if (error.message !== 'out-of-stock') {
					this.app.msgSvc.add({
						severity: 'error',
						detail: 'Error validating order',
						key: 'sidebar',
					});
					console.error(error);
				}
				return;
			}

			if (!this.savedCheck) {
				this.continueMessage = 'Continue';
				this.checkoutStep = 'orderDetails';
				this.app.msgSvc.clear();

				if (this.orderType && this.orderType.tipped) {
					this.selectTip(this.tipSelected);
				}

				if (this.check.futureOrder === 'later' && this.futureOrderDate && this.futureOrderTime) {
					this.check.futureOrderTime = moment(this.futureOrderDate)
						.hour(this.futureOrderTime.split(':')[0])
						.minute(this.futureOrderTime.split(':')[1])
						.second(0)
						.format();
					await this.getLeadTime(this.check, this.orderType.key, moment(this.check.futureOrderTime).format('HH:mm'));
					// this.dev('check-future-order-time', this.check.futureOrderTime);
				}

				return;
			}

			if (this.savedCheck) {
				await this.updateOrder(this.order);
				return;
			}
		}

		if (this.checkoutStep === 'orderDetails') {
			this.continueMessage = '';
			this.checkoutStep = 'paymentMethod';
			if (this.venue.ccProcessor === 1 && this.orderType.payCreditCard) {
				this.i4goCardOther = true;
				this.paymentMode = undefined;
			}

			// if (this.kioskMode && this.kioskDeviceId) {
			// 	const kioskPaymentRequest = await this.kioskPaymentService.buildPaymentRequest(this.order.checkKey, this.order.total);
			// 	await this.kioskPaymentService.performPaymentRequest(this.venue.venueKey, kioskPaymentRequest);
			// 	this.kioskPaymentService.paymentResponseSubscriptpion.add(this.kioskPaymentService.paymentResponse.subscribe(data =>{
			// 		console.log(`Kiosk payment received`)
			// 		this.paymentKioskResponse(data)
			// 	}))
			// }

			this.app.msgSvc.clear();

			if (!this.onlineCustomer && this.orderType.storeCustomerData) {
				this.onlineCustomer = new OnlineCustomer({
					firstName: this.check.billing.firstName,
					lastName: this.check.billing.lastName,
					email: this.check.billing.email,
					phone: this.check.billing.phone,
				});
				this.storage.set(OnlineCustomerCode.ONLINECUSTOMER, this.onlineCustomer);
			}

			this.allowSubmit = false;
			return;
		}

		if (this.checkoutStep === 'paymentMethod' || this.checkoutStep === 'giftCard') {
			if (this.paymentMode === 'store') {
				this.check.tip = 0;
				this.updateCheckTotals(this.check);
				if (this.customerCardToken) {
					this.check.billing.firstName = this.customer.firstName;
					this.check.billing.lastName = this.customer.lastName;
					this.check.billing.email = this.customer.email;
					this.check.billing.phone = this.customer.phone;
				}
				this.processOrder(this.order);
				return;
			}

			if (this.paymentMode === 'gift') {
				this.giftAccount = null;
				this.giftAmount = null;
				this.checkoutStep = 'giftCard';
				this.app.msgSvc.clear();
				return;
			}

			if (this.customerCardToken) {
				this.paymentMode = 'token';
				const card = this.customerCards.find((cc) => cc.value === this.customerCardToken);
				this.check.creditCard.displayName = card.label;
				this.check.creditCard.cardNumber = null;
				this.check.creditCard.cardCvv = null;
				this.check.creditCard.cardExpirationMonth = null;
				this.check.creditCard.cardExpirationYear = null;
				this.check.billing.address1 = null;
				this.check.billing.address2 = null;
				this.check.billing.city = null;
				this.check.billing.state = null;
				this.check.billing.postalCode = null;
				this.check.billing.country = null;
				this.check.billing.firstName = this.customer.firstName;
				this.check.billing.lastName = this.customer.lastName;
				this.check.billing.email = this.customer.email;
				this.check.billing.phone = this.customer.phone;
				this.continueMessage = 'Submit Order';
				this.checkoutStep = 'orderReview';
				this.app.msgSvc.clear();
				return;
			}

			if (this.paymentMode === 'form') {
				if (
					this.check.creditCard.cardNumber &&
					this.check.creditCard.cardExpirationMonth &&
					this.check.creditCard.cardExpirationYear &&
					this.check.creditCard.cardCvv
				) {
					this.processOrder(this.order);
				}
			}

			this.continueMessage = 'Submit Order';
			// this.checkoutStep = "orderReview";
			this.app.msgSvc.clear();
			return;
		}

		if (this.checkoutStep === 'orderReview') {
			await this.processOrder(this.order);
			return;
		}

		if (this.checkoutStep === 'orderComplete' || this.checkoutStep === 'paymentComplete') {
			this.sbCart.close();
			this.reset(true);
			return;
		}

		this.dev(this.checkoutStepNum + ' ' + this.checkoutStep);
	}

	async paymentAuth(payment: OrderPayment) {
		if (this.query.test) {
			return this.fakeCCPayload;
		}
		const res = await this.focuslink.paymentAuth(this.venueKey, payment);
		switch (this.venue.ccProcessor) {
			case CCProcessors.SHIFT4:
				this.paymentInvoiceNumber = +res.transId;
				break;
			case CCProcessors.FOCUSPAYDATACAP:
				this.paymentInvoiceNumber = moment().unix();
				this.paymentToken = res.Token;
				if (res.Status === DatacapPaymentStatus.DECLINED) {
					throw new Error(this.app.references.toTitleCase(res.Message));
				}
				break;
		}
		if (this.venue.ccProcessor === CCProcessors.SHIFT4) {
		}

		this.dev(res);
		return res;
	}

	getCardType(cardType: string): string {
		if (cardType == 'AX' || cardType == 'AmericanExpress') {
			return 'American Express';
		} else if (cardType == 'AP') {
			return 'Alipay';
		} else if (cardType == 'DB') {
			return 'Debit card';
		} else if (cardType == 'JC') {
			return 'JCB';
		} else if (cardType == 'MC') {
			return 'Mastercard';
		} else if (cardType == 'NS') {
			return 'Discover';
		} else if (cardType == 'VS') {
			return 'Visa';
		} else {
			return cardType;
		}
	}

	parseOrderError(error: string) {
		let message = 'Sending order to POS';

		try {
			const errObj = JSON.parse(error);
			if (errObj.message === 'payment-auth') {
				message = 'Processing payment';
				if (errObj.detail) {
					try {
						const detailObj = JSON.parse(errObj.detail);
					} catch (error) {}
				}
			}
		} catch (error) {}

		return message;
	}

	routeExternalUrl(url: string) {
		this.app.routeExternal(url);
	}

	selectCanvas(event: any) {
		let canvas;
		if (event.canvasKey) {
			canvas = event;
		} else {
			canvas = this.ooCanvasesOnline.find((i) => i.canvasKey === event.value);
		}
		if (canvas.externalUrl) {
			if (this.check?.items?.length > 0) {
				this.app.confirmation.confirm({
					message: `You have items in your cart. Visiting this page will clear your cart. Continue?`,
					accept: async () => {
						this.routeExternalUrl(event.externalUrl);
					},
					reject: async () => {
						this.app.confirmation.close();
					},
				});
			} else {
				this.routeExternalUrl(event.externalUrl);
			}
		} else {
			const element = document.getElementById(`canvas-${canvas.canvasKey}`);
			element.focus({ preventScroll: false });
			element.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
		}
	}

	selectCanvasEvaluate(canvasKey) {
		this.selectedCanvasKey = canvasKey;
		this.canvasSelected = this.ooCanvasesOnline.find((i) => i.canvasKey === canvasKey);
	}

	dev(msg: any) {
		if (isDevMode()) {
			console.log(msg);
		}
	}

	googleAnalyiticsPost(order: Order) {
		const gTagOrderEvent = {
			transaction_id: order.checkKey,
			affiliation: `${this.venueKey} - ${this.venue.name}`,
			value: order.total,
			currency: 'USD',
			tax: order.taxtotal,
			shipping: 0,
			items: [],
		};

		order.seats.forEach((seat) => {
			seat.items.forEach((item) => {
				gTagOrderEvent.items.push({
					id: item.menuItemKey.toString(),
					name: item.name,
					brand: this.venue.name,
					category: 'Food',
					quantity: item.quantity,
					price: item.price,
				});
			});
		});

		this.googleAnalytics.purchaseEmitter(gTagOrderEvent);
	}

	fakeCCPayload =
		'{"result":[{"dateTime":"2021-09-20T20:56:00.000-07:00","receiptColumns":30,"amount":{"tip":3.06,"total":21.61},"card":{"type":"VS","entryMode":"M","number":"XXXXXXXXXXXX1119","present":"N","token":{"value":"8048361737091119"}},"clerk":{"numericId":7166},"device":{"capability":{"magstripe":"Y","manualEntry":"Y"}},"merchant":{"mid":7215536,"name":"Focus - F&B"},"receipt":[{"key":"MaskedPAN","printValue":"XXXXXXXXXXXX1119"},{"key":"CardEntryMode","printName":"ENTRY METHOD","printValue":"KEYED"},{"key":"SignatureRequired","printValue":"Y"}],"server":{"name":"UTGAPI10CE"},"transaction":{"authorizationCode":"OK323Z","authSource":"E","invoice":"1632171360","purchaseCard":{"productDescriptors":["Food"]},"responseCode":"A","saleFlag":"S"},"universalToken":{"value":"432100-2D5C1A5C-001138-0000183B-16B4581E8CE"}}],"transId":1632171360,"authCode":"OK323Z","cardType":"VS","cardNumber":"XXXXXXXXXXXX1119","last4":1119,"token":"8048361737091119"}';
}

// 4321000000001119
// 4417010617574247 - host error
// cvv 4444 - error
// address or zip 78 - error

// 1584829547

// backup payment flow => tab token

// 7136233591
